// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournamentSummaryCard {
  margin-top: 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  padding: 0 24px 24px 24px;
}

.GenericSummary.tournamentSummary {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.GenericSummary.tournamentSummary .GenericSummary__tabs {
  flex: 0 0 auto;
  padding: 20px 0 0 0;
  background: #fff;
}

.GenericSummary.tournamentSummary .GenericSummary__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: visible;
  padding: 0;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  flex-wrap: wrap;
  margin: 0 !important;
  padding: 0 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  list-style: none !important;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item {
  display: block !important;
  margin-bottom: 0 !important;
  list-style: none !important;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item::marker {
  content: none !important;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 10px 14px;
  border: none !important;
  border-radius: 10px 10px 0 0;
  background: transparent;
  color: #5b6875;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  box-shadow: none !important;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link:hover {
  color: #1f2d3d;
  background: rgba(23, 162, 184, 0.06);
  text-decoration: none;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link:focus {
  outline: none;
  text-decoration: none;
  box-shadow: inset 0 -2px 0 #17a2b8 !important;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link.active {
  color: #0f6f7d !important;
  background: #eef9fb !important;
  border: none !important;
  box-shadow: inset 0 -2px 0 #17a2b8 !important;
}

.tournamentSummaryActions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 16px 0 14px 0;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.tournamentSummaryActions .btn,
.tournamentSummaryActions button {
  margin: 0 !important;
}

.tournamentSummaryActions:empty {
  display: none;
}

.tournamentSummaryBody {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.tournamentSummaryHero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 14px 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.025), rgba(0, 0, 0, 0.01));
}

.tournamentSummaryHeroMain {
  min-width: 0;
  flex: 1 1 420px;
}

.tournamentSummaryTitle {
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
  color: #1f2d3d;
}

.tournamentSummaryDescription {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.5;
  color: #5b6875;
}

.tournamentSummaryDescription p:last-child {
  margin-bottom: 0;
}

.tournamentSummaryDescription--muted {
  color: #8a94a1;
}

.tournamentSummaryHeroSide {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex: 0 0 auto;
}

.tournamentSummaryPill {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #0f6f7d;
  background: #e8f8fb;
  border: 1px solid rgba(23, 162, 184, 0.18);
}

.tournamentSummaryPill--subtle {
  color: #4b5563;
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.08);
}

.tournamentSummaryGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 1100px) {
  .tournamentSummaryGrid {
    grid-template-columns: 1fr;
  }
}

.tournamentSummaryItem {
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  background: #fff;
}

.tournamentSummaryItemLabel {
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8b96a3;
}

.tournamentSummaryItemValue {
  margin-top: 8px;
  font-size: 16px;
  line-height: 1.45;
  color: #233142;
  word-break: break-word;
}

@media (max-width: 900px) {
  .tournamentSummaryGrid {
    grid-template-columns: 1fr;
  }
}

.tournamentSummaryInlineGroups {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tournamentSummaryInlineGroup {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.025);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.tournamentSummaryInlineGroupLabel {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  color: #7b8794;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.tournamentSummaryInlineGroupValue {
  min-width: 0;
  font-size: 13px;
  line-height: 1.35;
  color: #1f2d3d;
  word-break: break-word;
}

.tournamentAutoEnrollmentKpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.tournamentAutoEnrollmentKpi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
}

.tournamentAutoEnrollmentKpiLabel {
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.tournamentAutoEnrollmentKpiValue {
  font-size: 18px;
  font-weight: 800;
  line-height: 1.1;
  color: #1f2d3d;
}

@media (max-width: 900px) {
  .tournamentAutoEnrollmentKpis {
    grid-template-columns: 1fr;
  }
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary {
  row-gap: 2px;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item {
  margin-top: 0 !important;
}

.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link {
  min-height: 38px;
  padding: 8px 14px;
}

.GenericSummary.tournamentSummary .GenericSummary__tabs {
  margin-bottom: 2px;
}

.tAeSwitchGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 18px;
  margin-bottom: 18px;
}

.tAeSwitchItem {
  margin: 0 !important;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: #fff;
}

@media (max-width: 900px) {
  .tAeSwitchGrid {
    grid-template-columns: 1fr;
  }
}

.tAeFooter {
  padding: 12px 0 0 0 !important;
  margin-top: 18px;
  background: transparent !important;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.tAeFooter .btn,
.tAeFooter button {
  min-width: 108px;
}

.tournamentSummaryLinkStack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.tournamentSummaryLinkStack .tournamentSummaryInlineGroup {
  max-width: 100%;
}

.tournamentSummaryLinkStack .tournamentSummaryInlineGroupValue {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.tournamentSummaryPill--yes,
.tournamentSummaryPill--enabled {
  color: #166534;
  background: #dcfce7;
  border-color: #bbf7d0;
}

.tournamentSummaryPill--no,
.tournamentSummaryPill--disabled {
  color: #6b7280;
  background: #f3f4f6;
  border-color: #e5e7eb;
}

/* Upcoming / archive tournament lists */
.unionTournamentsModern {
  width: 100%;
  min-width: 0;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.unionTournamentsHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 0 0 12px;
}
.unionTournamentsHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.01em;
}
.unionTournamentsAdd {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 1px solid var(--brand-600, #227ebd);
  border-radius: 9px;
  background: var(--brand-600, #227ebd);
  color: #fff;
  font-size: 13px;
  font-weight: 750;
  box-shadow: none;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}
.unionTournamentsAdd:hover {
  border-color: var(--action-primary-hover, #1a6da3);
  background: var(--action-primary-hover, #1a6da3);
  color: #fff;
  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.2);
}
.unionTournamentsTabs {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}
.unionTournamentsTabs button {
  display: inline-flex;
  height: 40px;
  align-items: center;
  gap: 8px;
  padding: 0 15px;
  border: 0;
  border-bottom: 2.5px solid transparent;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  font-weight: 650;
}
.unionTournamentsTabs button.isActive {
  border-bottom-color: var(--brand-600, #227ebd);
  color: var(--text-strong, #0f172a);
  font-weight: 750;
}
.unionTournamentsTabs span {
  display: inline-flex;
  min-width: 20px;
  height: 19px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--blue-50, #eef7fc);
  color: var(--blue-700, #155d8c);
  font-size: 11.5px;
}

/* Shell & Header — Direction B, organiser-side tournament lists. */
.unionTournamentsPageHeader {
  height: 70px;
  min-width: 0;
  margin: -20px -30px 18px -22px;
  padding: 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.unionTournamentsModern.unionTournamentsListShell,
.schoolInvitesHub.unionTournamentsListShell {
  max-width: none;
}

/* Escape both nested content gutters so the page header reaches from the sidebar edge to the viewport edge. */
.unionTournamentsPage .unionTournamentsPageHeader {
  width: calc(100% + 100px);
  margin: -40px 0 18px -28px;
}

.schoolInvitesHub.unionTournamentsListShell {
  box-sizing: border-box;
  padding-right: 4px;
  padding-left: 4px;
}

.schoolInvitesHub.unionTournamentsListShell .unionTournamentsPageHeader {
  width: calc(100% + 56px);
  margin: -38px 0 18px -28px;
}

.unionTournamentsPageHeader h1 {
  flex: 0 0 auto;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.unionTournamentsPageHeader .unionTournamentsTabs {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
  align-items: stretch;
  gap: 26px;
  overflow-x: auto;
  margin: 0;
  border-bottom: 0;
}

.unionTournamentsPageHeader .unionTournamentsTabs button {
  position: relative;
  height: auto;
  flex: 0 0 auto;
  padding: 1px 0 0;
  border: 0;
  color: var(--text-muted, #64748b);
  font-size: 15px;
  font-weight: 650;
  white-space: nowrap;
}

.unionTournamentsPageHeader .unionTournamentsTabs button::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: transparent;
}

.unionTournamentsPageHeader .unionTournamentsTabs button:hover {
  color: var(--text-strong, #0f172a);
}

.unionTournamentsPageHeader .unionTournamentsTabs button.isActive {
  color: var(--blue-600, #1a6da3);
}

.unionTournamentsPageHeader .unionTournamentsTabs button.isActive::after {
  background: var(--blue-500, #227ebd);
}

.unionTournamentsPageHeader .unionTournamentsTabs span {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.unionTournamentsPageHeader .unionTournamentsTabs button.isActive span {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.unionTournamentsPageHeader .unionTournamentsTabs span.unionTournamentsUnreadCount,
.unionTournamentsPageHeader .unionTournamentsTabs button.isActive span.unionTournamentsUnreadCount {
  background: var(--amber-100, #ffedc2);
  color: var(--amber-800, #8a4b08);
}

.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart {
  display: inline-flex;
  min-width: auto;
  height: 32px;
  flex: 0 0 auto;
  align-self: center;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid var(--amber-100, #ffe9c2);
  border-radius: 999px;
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart b {
  color: inherit;
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 13px;
  font-weight: 850;
}

.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert {
  display: inline-flex;
  min-width: auto;
  height: 32px;
  flex: 0 0 auto;
  align-self: center;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid var(--red-100, #f9d4d9);
  border-radius: 999px;
  background: var(--red-50, #fdecee);
  color: var(--red-700, #a52836);
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
}

.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert b {
  color: inherit;
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 13px;
  font-weight: 850;
}

.unionTournamentsPageHeader .unionTournamentsAdd {
  height: 40px;
  flex: 0 0 auto;
  border-radius: var(--radius-md, 8px);
  font-size: 14px;
  font-weight: 650;
}

.unionTournamentsSummaryStrip {
  display: flex;
  width: calc(100% + 56px);
  min-height: 58px;
  align-items: center;
  gap: 10px;
  margin: -18px 0 18px -28px;
  padding: 14px 72px 14px 28px;
  overflow-x: auto;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}
.unionTournamentsSummaryStrip > button,
.unionTournamentsSummaryStrip > span {
  display: inline-flex;
  min-width: max-content;
  min-height: 32px;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 650;
}
.unionTournamentsSummaryStrip > button { cursor: pointer; }
.unionTournamentsSummaryStrip b {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 15px;
  font-weight: 800;
}
.unionTournamentsSummaryStrip .unionTournamentsNextStart,
.unionTournamentsSummaryStrip .unionTournamentsConfirmationAlert {
  border-color: var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
  cursor: pointer;
}
.unionTournamentsSummaryStrip .unionTournamentsNextStart b,
.unionTournamentsSummaryStrip .unionTournamentsConfirmationAlert b { color: inherit; }
.unionTournamentsSummaryStrip .unionTournamentsSummaryContext {
  margin-left: auto;
  cursor: default;
}
.schoolInvitesHub.unionTournamentsListShell .unionTournamentsSummaryStrip {
  width: calc(100% + 56px);
  margin-left: -28px;
}

.unionTournamentsModern .unionTournamentsListCard {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
}

.unionTournamentsModern .unionTournamentsListCard .gridPanelTitleRow {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.unionTournamentsModern .unionTournamentsListCard .gridPanelTitle {
  padding: 0 !important;
}

.unionTournamentsModern .unionTournamentsListCard .gridPanelTitle > h1 {
  margin: 0 10px 0 0;
  color: var(--text-muted, #64748b);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 13px;
  font-weight: 700;
  line-height: 40px;
}

.unionTournamentsModern .unionTournamentsListCard .gridModernFilterButton,
.unionTournamentsModern .unionTournamentsListCard .gridModernColumns > button,
.unionTournamentsModern .unionTournamentsListCard .unionTournamentsReportsButton {
  height: 32px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 650;
}

@media (max-width: 900px) {
  .unionTournamentsPageHeader {
    height: auto;
    min-height: 70px;
    flex-wrap: wrap;
    gap: 0 16px;
    padding-top: 10px;
  }
  .unionTournamentsPageHeader .unionTournamentsTabs {
    width: 100%;
    height: 42px;
    flex-basis: 100%;
    order: 3;
  }
  .unionTournamentsPageHeader .unionTournamentsAdd {
    margin-left: auto;
  }
}

@media (max-width: 1217px) {
  .unionTournamentsPage {
    padding-right: 16px;
    padding-left: 16px;
  }

  .unionTournamentsPage .unionTournamentsPageHeader {
    width: 100vw;
    margin-top: -36px;
    margin-left: -28px;
  }

  .schoolInvitesHub.unionTournamentsListShell {
    padding-right: 16px;
    padding-left: 16px;
  }

  .schoolInvitesHub.unionTournamentsListShell .unionTournamentsPageHeader {
    width: 100vw;
    margin-top: -34px;
    margin-left: -28px;
  }

  .unionTournamentsSummaryStrip,
  .schoolInvitesHub.unionTournamentsListShell .unionTournamentsSummaryStrip {
    width: 100vw;
    margin-left: -28px;
    padding-right: 28px;
  }
}

.utListTournament {
  display: flex;
  min-width: 260px;
  flex-direction: column;
  gap: 3px;
}
.utListTournament__title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: var(--text-strong, #0f172a);
  font-size: 13.5px;
  font-weight: 750;
  line-height: 1.3;
}
.utListTournament__meta {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  white-space: nowrap;
}
.utListTournament__meta i {
  width: 9px;
  height: 9px;
  flex: 0 0 9px;
  border-radius: 2px;
}
.utListTournament__meta b {
  color: var(--text-subtle, #94a3b8);
}
.utListDate {
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: nowrap;
}
.utListDate strong {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 650;
}
.utListDate span {
  color: var(--text-muted, #64748b);
  font-size: 11px;
}
.utListCapacity {
  display: flex;
  min-width: 120px;
  justify-content: space-between;
  color: var(--text-strong, #0f172a);
  font-size: 12.5px;
}
.utListCapacityBar {
  height: 5px;
  margin-top: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: var(--slate-100, #f1f5f9);
}
.utListCapacityBar i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--brand-500, #368fca);
}
.utListCapacityBar.is-nearly-full i {
  background: var(--amber-500, #e5a21a);
}
.utListCapacityBar.is-full i {
  background: var(--red-500, #dc4c64);
}
.utListBadge {
  display: inline-flex;
  min-height: 23px;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
}
.utListBadge.is-warning {
  background: var(--amber-50, #fff8e8);
  color: var(--amber-700, #805b16);
}
.utListBadge.is-success {
  background: var(--green-50, #edf8f1);
  color: var(--green-700, #287a50);
}
.utListBadge.is-neutral {
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
}
.utListBadge.is-info {
  background: var(--blue-50, #eef7fc);
  color: var(--blue-700, #155d8c);
}
.utListBadge.has-dot::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.utListCentered {
  text-align: center;
}
.utListMuted {
  color: var(--text-subtle, #94a3b8);
}
.utListWaitingCount {
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 700;
}
.utListWaitingCount.has-items {
  color: var(--amber-700, #805b16);
}
.utListBoolean {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-subtle, #94a3b8);
  font-weight: 800;
}
.utListBoolean.is-yes {
  background: var(--green-50, #edf8f1);
  color: var(--green-700, #287a50);
}
.utListTags {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.utListTags > span:not(.utListMuted) {
  display: inline-flex;
  height: 21px;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 11px;
  font-weight: 650;
}
.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert.is-clickable {
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert.is-clickable:hover,
.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert.is-clickable:focus-visible,
.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert.is-active {
  border-color: var(--red-300, #e7a2ab);
  background: var(--red-100, #f9d4d9);
  box-shadow: 0 0 0 3px rgba(165, 40, 54, 0.1);
  outline: none;
}
.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert i {
  display: inline-flex;
  width: 17px;
  height: 17px;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
  border-radius: 50%;
  background: rgba(165, 40, 54, 0.1);
  font-size: 14px;
  font-style: normal;
  line-height: 1;
}

.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart.is-clickable {
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart.is-clickable:hover,
.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart.is-clickable:focus-visible {
  border-color: var(--amber-300, #f2c46d);
  background: var(--amber-100, #ffedc7);
  box-shadow: 0 0 0 3px rgba(229, 162, 26, 0.14);
  outline: none;
}

.unionInvitesSegments {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 9px;
  background: var(--surface-sunken, #f1f5f9);
}
.unionInvitesSegments a {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  padding: 7px 14px;
  border-radius: 6px;
  color: var(--text-muted, #64748b);
  font-size: 13.5px;
  font-weight: 650;
  line-height: 1;
  text-decoration: none;
}
.unionInvitesSegments a:hover { color: var(--text-strong, #0f172a); text-decoration: none; }
.unionInvitesSegments a.is-active {
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.14);
}
.utListTags > span:not(.utListMuted) > em {
  overflow: hidden;
  max-width: 132px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.utListTags > span:not(.utListMuted) > i {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
}
.utListFlag {
  display: inline-flex;
  color: var(--amber-600, #c98312);
}
.utListFlag svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.unionTournamentsModern table.table tbody tr {
  height: 56px;
  cursor: pointer;
}
.unionTournamentsModern table.table tbody tr > td:last-child {
  position: relative;
  padding-right: 40px;
}
.unionTournamentsModern table.table tbody tr > td:last-child::after {
  content: '›';
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  color: var(--text-subtle, #94a3b8);
  font-size: 22px;
  line-height: 1;
  opacity: 0;
  transition: opacity 0.14s ease;
}
.unionTournamentsModern table.table tbody tr:hover > td:last-child::after {
  opacity: 1;
}
.utListStateIcon {
  display: inline-flex;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}
.utListStateIcon svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.utListStateIcon.is-published {
  background: var(--green-50, #edf8f1);
  color: var(--green-700, #287a50);
}
.utListStateIcon.is-highlighted {
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}
.utListStateIcon.is-highlighted svg { fill: currentColor; stroke-width: 1.4; }

.unionTournamentsModern .gridPanelModern {
  margin-bottom: 12px;
}
.unionTournamentsPage {
  min-height: calc(100vh - 76px);
  padding: 20px 72px 32px 4px;
  background: var(--surface-page, #f5f7fb);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}
.unionTournamentsPage > .row {
  margin: 0;
}
.unionTournamentsPage > .row > [class*='col-'] {
  padding: 0;
}
.unionTournamentsModern {
  width: 100%;
  max-width: 1280px;
}
.unionTournamentsModern button,
.unionTournamentsModern input,
.unionTournamentsModern select {
  font-family: inherit;
}
.unionTournamentsModern button {
  cursor: pointer;
  text-transform: none;
}
.unionTournamentsModern > .container-fluid {
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}
.unionTournamentsModern .gridPanelTitleRow {
  margin: 0;
}
.unionTournamentsModern .gridPanelTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 0 12px !important;
}
.unionTournamentsModern .gridPanelTitle > h1 {
  order: 0;
  margin: 0 10px 0 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 20px;
  font-weight: 800;
  line-height: 40px;
  white-space: nowrap;
}
.unionTournamentsModern .gridPanelTitle > h1 + span {
  order: 0;
  display: inline-flex;
  min-width: 25px;
  height: 23px;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11px;
  font-weight: 800;
}
.unionTournamentsModern .table {
  margin-top: 0 !important;
}

.unionTournamentsModern .gridModernToolbar {
  align-items: flex-end;
}

.unionTournamentsModern .gridModernSearch {
  order: 1;
  display: inline-flex;
  width: min(360px, 100%);
  height: 40px;
  align-items: center;
  margin: 0;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  box-shadow: none;
}
.unionTournamentsModern .gridModernSearch:focus-within {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}
.unionTournamentsModern .gridModernSearch input {
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-strong, #0f172a);
  font-size: 13px;
}
.unionTournamentsModern .gridModernSearch__clear {
  width: 26px;
  height: 26px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 20px;
  line-height: 1;
}
.unionTournamentsModern .gridModernSearch__clear:hover {
  background: var(--slate-100, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.unionTournamentsModern .gridModernFiltersAnchor,
.unionTournamentsModern .gridModernColumns {
  position: relative;
  flex: 0 0 auto;
}
.unionTournamentsModern .gridModernFiltersAnchor {
  order: 2;
}
.unionTournamentsModern .gridModernColumns {
  order: 3;
}
.unionTournamentsModern .gridModernAdditionalOptions {
  order: 4;
}
.unionTournamentsModern .gridModernFilterButton,
.unionTournamentsModern .gridModernColumns > button,
.unionTournamentsReportsButton {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin: 0;
  padding: 0 13px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  box-shadow: none;
  font-size: 13px;
  font-weight: 700;
}
.unionTournamentsModern .gridModernFilterButton:hover,
.unionTournamentsModern .gridModernFilterButton.is-active,
.unionTournamentsModern .gridModernColumns > button:hover,
.unionTournamentsReportsButton:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}
.unionTournamentsReportsButton::before {
  content: '';
  width: 16px;
  height: 16px;
  background: currentColor;
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 4h14v16H5zM8 8h8M8 12h8M8 16h5' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")
    center/16px no-repeat;
}
.unionTournamentsModern .gridModernFilterButton > span,
.unionTournamentsModern .gridModernColumns > button > span {
  width: 16px;
  height: 16px;
  background: currentColor;
}
.unionTournamentsModern .gridModernFilterButton > span {
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E")
    center/16px no-repeat;
}
.unionTournamentsModern .gridModernColumns > button > span {
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E")
    center/16px no-repeat;
}
.unionTournamentsModern .gridModernFilterButton b,
.unionTournamentsModern .gridModernColumns > button b {
  display: inline-flex;
  min-width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 10.5px;
}
.unionTournamentsModern .gridModernFilterButton.is-active b {
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.unionTournamentsModern .gridModernFilterPopover {
  position: fixed;
  z-index: 2147483001;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  flex-direction: column;
  margin: 0;
  border: 0;
  border-left: 1px solid var(--border-subtle, #d9e2ec);
  border-radius: 0;
  background: var(--surface-card, #fff);
  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);
}
.unionTournamentsModern .gridModernFilterPopover > header {
  display: flex;
  min-height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  margin: 18px 18px 0;
  padding: 0 0 12px;
  border-bottom: 1px solid var(--border-subtle, #e6ebf1);
}
.unionTournamentsModern .gridModernFilterPopover > header strong {
  color: var(--text-strong, #172b4d);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 16px;
  font-weight: 800;
}
.unionTournamentsModern .gridModernFilterPopover > header button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: var(--radius-md, 8px);
  background: transparent;
  color: var(--text-muted, #667085);
  font-size: 23px;
  line-height: 1;
}
.unionTournamentsModern .gridModernFilterPopover > header button:hover {
  background: var(--surface-hover, #f2f6fa);
  color: var(--text-strong, #172b4d);
}
.unionTournamentsModern .gridModernFilterPopover__fields {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 18px;
  padding: 18px 18px 24px;
  overflow-x: hidden;
  overflow-y: auto;
}
.unionTournamentsModern .gridModernFilterPopover__fields > label {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 7px;
  margin: 0;
}
.unionTournamentsModern .gridModernFilterPopover__fields > label > span,
.unionTournamentsModern .gridModernFilterPopover .gridModernFilterChips legend,
.unionTournamentsModern .gridModernFilterPopover .sit-dp__label {
  margin: 0;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}
.unionTournamentsModern .gridModernFilterPopover__fields input,
.unionTournamentsModern .gridModernFilterPopover__fields select,
.unionTournamentsModern .gridModernFilterPopover .sit-dp__trigger {
  width: 100%;
  min-height: 40px;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background-color: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  box-shadow: none;
}
.unionTournamentsModern .gridModernFilterPopover__fields select {
  padding-right: 32px;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
}
.unionTournamentsModern .gridModernFilterPopover__fields input:focus,
.unionTournamentsModern .gridModernFilterPopover__fields select:focus,
.unionTournamentsModern .gridModernFilterPopover .sit-dp__trigger:focus-within {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));
}
.unionTournamentsModern .gridModernFilterChips {
  margin: 0;
  padding: 0;
  border: 0;
}
.unionTournamentsModern .gridModernFilterChips > div {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.unionTournamentsModern .gridModernFilterChips button {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 650;
}
.unionTournamentsModern .gridModernFilterChips button:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
}
.unionTournamentsModern .gridModernFilterChips button.is-selected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.unionTournamentsModern .gridModernFilterChips button.has-option-color {
  border-color: color-mix(in srgb, var(--grid-filter-option-color) 52%, #cbd5e1);
  background: color-mix(in srgb, var(--grid-filter-option-color) 12%, #fff);
  color: color-mix(in srgb, var(--grid-filter-option-color) 78%, #0f172a);
}
.unionTournamentsModern .gridModernFilterChips button.has-option-color.is-selected {
  border-color: var(--grid-filter-option-color);
  background: var(--grid-filter-option-color);
  color: #fff;
}
.unionTournamentsModern .gridModernFilterPopover > footer {
  display: flex;
  min-height: 69px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 18px;
  border-top: 1px solid var(--border-subtle, #e6ebf1);
  background: var(--surface-card, #fff);
}
.unionTournamentsModern .gridModernFilterPopover > footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.unionTournamentsModern .gridModernFilterPopover > footer button {
  min-height: 38px;
  padding: 0 13px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 700;
}
.unionTournamentsModern .gridModernFilterPopover > footer button.is-clear {
  padding: 0;
  border-color: transparent;
  background: transparent;
  color: var(--text-link, #1a6da3);
}
.unionTournamentsModern .gridModernFilterPopover > footer button.is-apply {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.unionTournamentsModern .gridModernFilterPopover > footer button.is-apply:hover {
  border-color: var(--action-primary-hover, #1a6da3);
  background: var(--action-primary-hover, #1a6da3);
}
.unionTournamentsModern .gridModernFilterPopover .sit-dp__pop {
  position: fixed;
  z-index: 2147483002;
  top: 50%;
  left: 50%;
  right: auto;
  transform: translate(-50%, -50%);
}
.unionTournamentsModern .gridModernColumns__menu {
  position: absolute;
  top: 46px;
  right: 0;
  z-index: 1070;
  width: 260px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-lg, 0 18px 40px rgba(15, 23, 42, 0.16));
}
.unionTournamentsModern .gridModernColumns__menu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 8px 9px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.unionTournamentsModern .gridModernColumns__menu header button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font-size: 12px;
  font-weight: 700;
}
.unionTournamentsModern .gridModernColumns__menu label {
  display: flex;
  min-height: 34px;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 7px 8px;
  border-radius: var(--radius-sm, 6px);
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 600;
}
.unionTournamentsModern .gridModernColumns__menu label:hover {
  background: var(--surface-hover, #f8fafc);
}
.unionTournamentsModern .gridModernColumns__menu input,
.unionTournamentsModern table input[type='checkbox'] {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--action-primary, #227ebd);
}

.unionTournamentsModern table .custom-checkbox input[type='checkbox'] {
  position: relative;
  display: block;
  width: 16px;
  height: 16px;
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  border: 1.5px solid var(--border-strong, #aebaca);
  border-radius: 4px;
  background: var(--surface-card, #fff);
  box-shadow: none;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.unionTournamentsModern table .custom-checkbox input[type='checkbox']:hover {
  border-color: var(--action-primary, #227ebd);
}

.unionTournamentsModern table .custom-checkbox input[type='checkbox']:focus-visible {
  border-color: var(--action-primary, #227ebd);
  outline: none;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.18);
}

.unionTournamentsModern table .custom-checkbox input[type='checkbox']:checked {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}

.unionTournamentsModern table .custom-checkbox input[type='checkbox']:checked::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 1.5px 1.5px 0;
  transform: rotate(45deg);
}

.unionTournamentsModern table .custom-checkbox input[type='checkbox']:disabled {
  border-color: var(--border-subtle, #dbe3ec);
  background: var(--surface-disabled, #f1f5f9);
  cursor: not-allowed;
  opacity: 0.75;
}

.unionTournamentsModern .gridTableActions {
  display: flex;
  min-height: 0;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 8px 14px;
  flex-wrap: wrap;
  border: 1px solid var(--blue-100, #cfe5f2);
  border-radius: var(--radius-md, 8px);
  background: var(--blue-50, #eef6fc);
  box-shadow: none;
}
.unionTournamentsModern .gridTableActions > span {
  margin-right: 4px;
  color: var(--blue-700, #155d8c);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.unionTournamentsModern .gridTableActions > div {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.unionTournamentsModern .gridTableActions button {
  display: inline-flex;
  height: 32px;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 10px;
  background: #fff;
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.unionTournamentsModern .gridTableActions button:hover,
.unionTournamentsModern .gridTableActions button:focus-visible {
  border-color: var(--blue-300, #8fc4e3);
  background: var(--blue-50, #eef7fc);
  color: var(--blue-700, #155d8c);
  outline: none;
}

.unionTournamentsModern .gridTableActions button.is-danger {
  border-color: var(--red-600, #dc2626);
  background: var(--red-600, #dc2626);
  color: #fff;
}

.unionTournamentsModern .gridTableActions button.is-danger:hover,
.unionTournamentsModern .gridTableActions button.is-danger:focus-visible {
  border-color: var(--red-700, #b91c1c);
  background: var(--red-700, #b91c1c);
  color: #fff;
}

.unionTournamentsModern .table-responsive {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 0;
  background: #fff;
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}

.unionTournamentDeleteModal .modal-content {
  border: 1px solid var(--border-subtle, #dbe3ec) !important;
  border-radius: 14px !important;
  box-shadow: 0 20px 54px rgba(15, 23, 42, 0.2) !important;
}
.unionTournamentDeleteModal .modal-header,
.unionTournamentDeleteModal .modal-footer {
  padding: 16px 20px !important;
  border-color: var(--border-subtle, #dbe3ec) !important;
  background: #fff !important;
}
.unionTournamentDeleteModal .modal-body {
  padding: 20px !important;
}
.unionTournamentDeleteModal__body {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.unionTournamentDeleteModal__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid #fecdd3;
  border-radius: 11px;
  background: #fff1f2;
  color: #be123c;
}
.unionTournamentDeleteModal__icon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}
.unionTournamentDeleteModal__copy {
  min-width: 0;
  flex: 1;
  color: var(--text-muted, #69778a);
  font-size: 13px;
}
.unionTournamentDeleteModal__copy > strong {
  color: var(--text-strong, #142033);
  font-weight: 760;
}
.unionTournamentDeleteModal__copy p {
  margin: 5px 0 0;
  line-height: 1.5;
}
.unionTournamentDeleteModal__blocker {
  margin-top: 9px;
  padding: 9px 11px;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  background: #fff7f8;
}
.unionTournamentDeleteModal__blocker b {
  display: block;
  color: var(--text-strong, #142033);
}
.unionTournamentDeleteModal__blocker ul {
  margin: 6px 0 0;
  padding-left: 18px;
  color: #9f1239;
  line-height: 1.45;
}
.unionTournamentDeleteModal__blocker li + li {
  margin-top: 3px;
}
.unionTournamentDeleteModal .modal-footer .btn-primary {
  border-color: #be123c !important;
  background: #be123c !important;
  color: #fff !important;
}
.unionTournamentDeleteModal .modal-footer .btn-primary:hover {
  border-color: #9f1239 !important;
  background: #9f1239 !important;
}
.unionTournamentsModern table.table {
  width: 100%;
  margin: 0 !important;
  border-collapse: separate;
  border-spacing: 0;
}
.unionTournamentsModern .selectAllCheckbox .eSelectAllCheckbox {
  z-index: 1080;
  min-width: 190px;
  padding: 6px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-lg, 0 18px 40px rgba(15, 23, 42, 0.16));
}
.unionTournamentsModern .selectAllCheckbox .dropdown-item {
  padding: 8px 10px;
  border-radius: var(--radius-sm, 6px);
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 600;
}
.unionTournamentsModern .selectAllCheckbox .dropdown-item:hover {
  background: var(--surface-hover, #f8fafc);
  color: var(--text-strong, #0f172a);
}
.unionTournamentsModern table.table th {
  padding: 11px 14px;
  border-top: 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  vertical-align: middle;
  white-space: nowrap;
}
.unionTournamentsModern table.table td {
  padding: 12px 14px;
  border-top: 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-body, #334155);
  font-size: 13px;
  vertical-align: middle;
}
.unionTournamentsModern table.table tbody tr,
.unionTournamentsModern table.table tbody tr > td {
  transform: none !important;
  box-shadow: none !important;
  transition: background 0.12s ease;
}
.unionTournamentsModern table.table tbody tr:hover,
.unionTournamentsModern table.table tbody tr:hover > td {
  background: var(--surface-hover, #f8fafc);
}
.unionTournamentsModern table.table tbody tr.table-primary,
.unionTournamentsModern table.table tbody tr.table-primary > td {
  background: var(--blue-50, #eef6fc) !important;
}
.unionTournamentsModern .gridActiveFilters {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  padding: 0 0 12px;
}
.unionTournamentsModern .gridActiveFilters > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
}

.unionTournamentsModern .gridActiveFilters > span > button {
  display: inline-flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  margin: 0 -3px 0 2px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: currentColor;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.unionTournamentsModern .gridActiveFilters > span > button:hover,
.unionTournamentsModern .gridActiveFilters > span > button:focus-visible {
  background: rgba(21, 93, 140, 0.12);
  outline: none;
}
.unionTournamentsModern .gridActiveFilters > button {
  padding: 0 4px;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font-size: 12px;
  font-weight: 700;
}
.unionTournamentsModern .gridModernPagination {
  margin: 12px 0 0;
  padding-bottom: 14px;
}
@media (max-width: 900px) {
  .unionTournamentsPage {
    padding-right: 4px;
  }
}

.utmEligible__removeError {
  margin-top: 14px;
  padding: 11px 12px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fef2f2;
  color: #991b1b;
  font-size: 13px;
  line-height: 1.45;
}

.utmEligibleActionModal .modal-content {
  border: 0 !important;
}

.utmEligibleActionModal__body {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.utmEligibleActionModal__icon {
  display: grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  place-items: center;
  border-radius: 12px;
  background: #eaf5fb;
  color: #1777a8;
}

.utmEligibleActionModal__icon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 2;
}

.utmEligibleActionModal__copy {
  min-width: 0;
}

.utmEligibleActionModal__copy > strong {
  color: #17243a;
  font-size: 15px;
}

.utmEligibleActionModal__copy p {
  margin: 7px 0 0;
  color: #64748b;
}

.utmEligibleAddModal {
  width: min(520px, calc(100vw - 40px));
  overflow: hidden;
  border: 1px solid #dbe4ee;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 65px rgba(15, 23, 42, 0.24);
}

.utmEligibleAddModal__header {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 34px;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid #e8edf3;
  background: #f8fafc;
}

.utmEligibleAddModal__headingIcon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 11px;
  background: #e8f4fb;
  color: #176f9f;
}

.utmEligibleAddModal__headingIcon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.9;
}

.utmEligibleAddModal__header h2 {
  margin: 0;
  color: #17243a;
  font-size: 18px;
  font-weight: 750;
  line-height: 1.25;
}

.utmEligibleAddModal__header p {
  margin: 3px 0 0;
  color: #718096;
  font-size: 12px;
}

.utmEligibleAddModal__header > button {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  padding: 0 0 2px;
  border: 1px solid #dbe4ee;
  border-radius: 9px;
  background: #fff;
  color: #64748b;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.utmEligibleAddModal__body {
  padding: 18px 20px 20px;
}

.utmEligibleAddModal__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 9px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.utmEligibleAddModal__summary b {
  display: grid;
  min-width: 24px;
  height: 24px;
  place-items: center;
  border-radius: 999px;
  background: #e8f4fb;
  color: #176f9f;
  font-size: 12px;
}

.utmEligibleAddModal__schools {
  overflow: auto;
  max-height: 190px;
  border: 1px solid #e2e8f0;
  border-radius: 11px;
}

.utmEligibleAddModal__schools > div {
  display: flex;
  min-height: 48px;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
}

.utmEligibleAddModal__schools > div + div {
  border-top: 1px solid #edf1f5;
}

.utmEligibleAddModal__schools > div > span {
  display: grid;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 8px;
  background: #eef2f7;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
}

.utmEligibleAddModal__schools > div > span img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.utmParticipants__schoolLogo,
.utmWaitingList__school > span {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  background: #fff;
}

.utmParticipants__schoolLogo img,
.utmWaitingList__school > span img {
  width: 100%;
  height: 100%;
  padding: 2px;
  object-fit: contain;
}

.utmEligibleAddModal__schools strong {
  color: #27364c;
  font-size: 13px;
  font-weight: 700;
}

.utmEligibleAddModal__notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 11px;
  border-radius: 9px;
  background: #f1f7fb;
  color: #45657a;
  font-size: 12px;
  line-height: 1.45;
}

.utmEligibleAddModal__notice svg {
  flex: 0 0 auto;
  margin-top: 1px;
  fill: none;
  stroke: #287da8;
  stroke-width: 1.8;
}

.utmEligibleAddModal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 14px 20px;
  border-top: 1px solid #e8edf3;
  background: #f8fafc;
}

.utmEligibleAddModal__footer button {
  min-height: 38px;
  padding: 0 15px;
  border: 1px solid #d6dee8;
  border-radius: 9px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.utmEligibleAddModal__footer button.is-primary {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.utmEligibleAddModal button:disabled {
  cursor: default;
  opacity: 0.6;
}
.unionTournamentsModern .bPagination--modern {
  min-height: 34px;
  justify-content: flex-end;
  gap: 10px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.unionTournamentReportsModal.modal-dialog {
  width: min(760px, calc(100vw - 24px));
  max-width: 760px;
}
.unionTournamentReportsModal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: var(--radius-xl, 16px);
  box-shadow: var(--shadow-xl, 0 24px 64px rgba(15, 23, 42, 0.22));
}
.unionTournamentReportsModal .modal-header {
  padding: 13px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}
.unionTournamentReportsModal .modal-title {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 17px;
  font-weight: 800;
}
.unionTournamentReportsModal .modal-body {
  padding: 18px 20px 20px;
  background: var(--surface-page, #f8fafc);
}
.unionTournamentReportsModal .eEventPrintModal__intro {
  margin-bottom: 18px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.5;
}
.unionTournamentReportsModal .eEventPrintModal__groupTitle {
  margin: 0 0 8px;
  color: var(--text-subtle, #94a3b8);
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}
.unionTournamentReportsModal .eEventPrintModal__list {
  display: grid;
  gap: 8px;
}
.unionTournamentReportsModal .eEventPrintModal__item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  color: inherit;
  text-align: left;
  box-shadow: none;
}
.unionTournamentReportsModal .eEventPrintModal__item:hover {
  border-color: var(--blue-400, #55a4d6);
  background: var(--blue-50, #eef8ff);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}
.unionTournamentReportsModal .eEventPrintModal__itemIcon {
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
}
.unionTournamentReportsModal .eEventPrintModal__itemIcon svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.unionTournamentReportsModal .eEventPrintModal__itemCopy {
  min-width: 0;
  flex: 1;
}
.unionTournamentReportsModal .eEventPrintModal__itemHeading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 750;
}
.unionTournamentReportsModal .eEventPrintModal__format {
  display: inline-flex;
  padding: 2px 6px;
  border-radius: 5px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.unionTournamentReportsModal .eEventPrintModal__itemDescription {
  display: block;
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.4;
}
.unionTournamentReportsModal .eEventPrintModal__arrow {
  color: var(--text-subtle, #94a3b8);
  font-size: 24px;
  line-height: 1;
}

.unionTournamentReportParametersModal.modal-dialog {
  width: min(480px, calc(100vw - 24px));
  max-width: 480px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.unionTournamentReportParametersModal .modal-content {
  max-height: min(720px, calc(100vh - 40px));
  overflow: hidden;
  border: 0;
  border-radius: var(--radius-xl, 16px);
  box-shadow: var(--shadow-xl, 0 24px 64px rgba(15, 23, 42, 0.22));
}
.unionTournamentReportParametersModal .modal-header {
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-subtle, #e3e8ef);
}
.unionTournamentReportParametersModal .modal-header .close {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border-radius: var(--radius-md, 8px);
  color: var(--text-muted, #64748b);
  font-size: 22px;
  text-shadow: none;
}
.unionTournamentReportTitle {
  display: flex;
  align-items: center;
  gap: 12px;
}
.unionTournamentReportTitle__icon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
}
.unionTournamentReportTitle__icon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.unionTournamentReportTitle > span:last-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
}
.unionTournamentReportTitle strong {
  color: var(--text-strong, #142033);
  font-size: 17px;
  font-weight: 800;
  line-height: 1.25;
}
.unionTournamentReportTitle small {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 500;
}
.unionTournamentReportParametersModal .modal-body {
  position: relative;
  min-height: 0;
  padding: 0 !important;
  overflow: hidden;
  background: var(--surface-page, #f8fafc);
}
.unionTournamentReportLoading {
  position: absolute;
  z-index: 5;
  inset: 0;
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 24px;
  background: rgba(255, 255, 255, 0.94);
  color: var(--text-strong, #0f172a);
  text-align: center;
}
.unionTournamentReportLoading__spinner {
  width: 28px;
  height: 28px;
  margin-bottom: 12px;
  border: 3px solid var(--blue-50, #eef6fc);
  border-top-color: var(--blue-500, #227ebd);
  border-radius: 50%;
  animation: unionTournamentReportSpin 0.75s linear infinite;
}
.unionTournamentReportLoading strong {
  font-size: 14px;
  font-weight: 800;
}
.unionTournamentReportLoading small {
  margin-top: 3px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}
@keyframes unionTournamentReportSpin {
  to { transform: rotate(360deg); }
}
.unionTournamentReportParametersModal__body > form {
  display: flex;
  max-height: calc(100vh - 116px);
  flex-wrap: wrap;
  padding-top: 12px;
  overflow-y: auto;
  color: var(--text-body, #334155);
  font-size: 13px;
}
.unionTournamentReportParametersModal__body .bReportFormTitle {
  display: none;
}
.unionTournamentReportParametersModal__body > form > .mb-3.mt-3,
.unionTournamentReportParametersModal__body .bReportFormTitle + .mb-3,
.unionTournamentReportParametersModal__body .form-group {
  box-sizing: border-box;
  width: calc(100% - 40px);
  margin: 6px 20px !important;
  padding: 12px 13px;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 11px;
  background: var(--surface-card, #fff);
}
.unionTournamentReportParametersModal__body > form > .mb-3.mt-3,
.unionTournamentReportParametersModal__body .bReportFormTitle + .mb-3 {
  margin-top: 6px !important;
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
  line-height: 1.5;
}
.unionTournamentReportParametersModal__body .form-group > .d-flex {
  align-items: center;
  gap: 9px;
}
.unionTournamentReportParametersModal__body label,
.unionTournamentReportParametersModal__body .form-check-label {
  margin: 0;
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 650;
}
.unionTournamentReportParametersModal__body .form-control {
  width: 100%;
  min-height: 40px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-strong, #142033);
  box-shadow: none;
}
.unionTournamentReportParametersModal__body .form-control:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.14));
}
.unionTournamentReportParametersModal__body form > .btn {
  min-width: 96px;
  min-height: 40px;
  order: 98;
  margin-top: 12px !important;
  margin-bottom: 16px !important;
  padding: 0 16px;
  border-radius: var(--radius-md, 8px);
  font-size: 13px;
  font-weight: 700;
  text-transform: none;
  box-shadow: none;
}
.unionTournamentReportParametersModal__body form > .btn-secondary {
  margin-right: 8px !important;
  margin-left: 20px !important;
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #475569);
}
.unionTournamentReportParametersModal__body form > .btn-primary {
  order: 99;
  margin-right: 20px !important;
  margin-left: auto !important;
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.unionTournamentReportParametersModal__body form > .btn-primary:hover {
  border-color: var(--action-primary-hover, #1a6da3);
  background: var(--action-primary-hover, #1a6da3);
}
.unionTournamentReportParametersModal__body .eReportForm {
  display: flex !important;
  min-height: 0;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0;
  overflow: hidden;
}
.unionTournamentReportParametersModal__body .eReportForm__content {
  min-height: 0;
  overflow-y: auto;
}
.unionTournamentReportParametersModal__body .eReportDescription {
  margin: 14px 18px 6px;
  padding: 11px 13px;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 9px;
  background: var(--slate-50, #f8fafc);
  color: var(--text-body, #334155);
  font-size: 12.5px;
  line-height: 1.5;
}
.unionTournamentReportParametersModal__body .eReportSection {
  margin: 13px 18px 0;
  padding-bottom: 13px;
  border-bottom: 1px solid var(--border-subtle, #e3e8ef);
}
.unionTournamentReportParametersModal__body .eReportSection:last-child {
  border-bottom: 0;
}
.unionTournamentReportParametersModal__body .eReportSection__heading {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-bottom: 9px;
}
.unionTournamentReportParametersModal__body .eReportSection__icon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
  font-size: 11px;
  font-weight: 800;
}
.unionTournamentReportParametersModal__body .eReportSection__copy {
  min-width: 0;
  flex: 1;
}
.unionTournamentReportParametersModal__body .eReportSection__title {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 750;
}
.unionTournamentReportParametersModal__body .eReportSection__hint {
  margin-top: 1px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}
.unionTournamentReportParametersModal__body .eReportSection__required {
  margin-left: 3px;
  color: var(--red-500, #d92d20);
}
.unionTournamentReportParametersModal__body .eReportToggleList {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 9px;
}
.unionTournamentReportParametersModal__body .eReportToggle {
  display: flex;
  min-height: 48px;
  align-items: center;
  gap: 14px;
  padding: 8px 11px;
  border-top: 1px solid var(--border-subtle, #e3e8ef);
  background: var(--surface-card, #fff);
}
.unionTournamentReportParametersModal__body .eReportToggle:first-child {
  border-top: 0;
}
.unionTournamentReportParametersModal__body .eReportToggle__copy {
  min-width: 0;
  flex: 1;
}
.unionTournamentReportParametersModal__body .eReportToggle__label {
  color: var(--text-strong, #142033);
  font-size: 12.5px;
  font-weight: 650;
}
.unionTournamentReportParametersModal__body .eReportToggle__hint {
  margin-top: 1px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
}
.unionTournamentReportParametersModal__body .eReportToggle .sit-switch {
  flex: 0 0 auto;
  margin: 0;
}
.unionTournamentReportParametersModal__body .eReportDateRange,
.unionTournamentReportParametersModal__body .eReportDateRange__picker {
  width: 100%;
}
.unionTournamentReportParametersModal__body .eReportDateRange .sit-dp__trigger {
  height: 40px;
  border-radius: var(--radius-md, 8px);
  font-size: 13px;
}
.unionTournamentReportParametersModal__body .eReportActions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 12px 18px;
  border-top: 1px solid var(--border-subtle, #e3e8ef);
  background: var(--slate-50, #f8fafc);
}
.unionTournamentReportParametersModal__body .eReportActions__status {
  flex: 1;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}
.unionTournamentReportParametersModal__body .eReportActions .eDsButton {
  min-width: 92px;
  min-height: 38px;
  margin: 0 !important;
  padding: 0 14px;
  border-radius: var(--radius-md, 8px);
  font-size: 13px;
  font-weight: 700;
  text-transform: none;
  box-shadow: none;
}
.unionTournamentReportParametersModal__body .eReportActions .eDsButton--secondary {
  border: 1px solid var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #475569);
}
.unionTournamentReportParametersModal__body .eReportActions .eDsButton--primary {
  border: 1px solid var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.unionTournamentReportParametersModal:has(.sit-dp__pop) .modal-content,
.unionTournamentReportParametersModal:has(.sit-dp__pop) .modal-body {
  overflow: visible;
}
.unionTournamentReportParametersModal .eReportDateRange .sit-dp__pop {
  position: fixed;
  z-index: 2147483002;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  max-width: calc(100vw - 24px);
  max-height: calc(100vh - 24px);
  transform: translate(-50%, -50%);
  animation: none;
}
.unionTournamentReportParametersModal .react-datepicker-popper {
  z-index: 2147483002;
}

@media (max-width: 600px) {
  .unionTournamentReportParametersModal.modal-dialog {
    width: calc(100vw - 20px);
  }
  .unionTournamentReportParametersModal__body .form-group,
  .unionTournamentReportParametersModal__body > form > .mb-3.mt-3,
  .unionTournamentReportParametersModal__body .bReportFormTitle + .mb-3 {
    width: calc(100% - 28px);
    margin-right: 14px !important;
    margin-left: 14px !important;
  }
}
.unionTournamentReportsModal__intro {
  margin-bottom: 12px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.5;
}
.unionTournamentReportsModal__group h3 {
  margin: 0 0 7px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.unionTournamentReportsModal__list {
  display: grid;
  gap: 6px;
}
.unionTournamentReportsModal__list > button {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) 16px;
  align-items: center;
  gap: 9px;
  width: 100%;
  min-height: 52px;
  padding: 8px 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  text-align: left;
  box-shadow: none;
}
.unionTournamentReportsModal__list > button:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
}
.unionTournamentReportsModal__icon {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background-color: var(--blue-50, #eef6fc);
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 3h8l4 4v14H6zM14 3v5h5M9 13h6M9 17h4' fill='none' stroke='%23227ebd' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 16px;
}
.unionTournamentReportsModal__list > button > span:nth-child(2) {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}
.unionTournamentReportsModal__list strong {
  color: var(--text-strong, #0f172a);
  font-size: 12.5px;
  font-weight: 750;
}
.unionTournamentReportsModal__list small {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.4;
}
.unionTournamentReportsModal__list b {
  color: var(--text-subtle, #94a3b8);
  font-size: 18px;
  font-weight: 400;
  text-align: center;
}

@media (max-width: 760px) {
  .unionTournamentsModern .gridModernSearch,
  .unionTournamentsModern .gridModernFiltersAnchor,
  .unionTournamentsModern .gridModernFilterButton,
  .unionTournamentsModern .gridInlineActions {
    width: 100%;
  }
  .unionTournamentsModern .gridModernFilterPopover {
    width: 100vw;
    max-width: none;
  }
}

@media (max-width: 1217px) {
  .unionTournamentsPage {
    padding-right: 16px;
    padding-left: 16px;
  }
}

.utmSchoolAdmins__download {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 14px;
  border: 1px solid var(--action-primary, #227ebd);
  border-radius: var(--radius-md, 8px);
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  box-shadow: none;
}

.utmSchoolAdmins__download svg {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.utmSchoolAdmins__download:disabled {
  cursor: default;
  opacity: 0.5;
}

.utmSchoolAdmins__headerTools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.utmSchoolAdmins__headerTools .gridModernSearch {
  width: 260px;
}

.utmSchoolAdmins__filterBackdrop {
  position: fixed;
  z-index: 2147483000;
  inset: 0;
}

.utmSchoolAdmins .utmParticipants__tableWrap table {
  font-family: var(--font-body, 'Inter', system-ui, sans-serif);
}

.utmSchoolAdmins .utmParticipants__tableWrap th {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.045em;
  text-transform: uppercase;
}

.utmSchoolAdmins .utmParticipants__tableWrap td {
  color: var(--text-body, #334155);
  font-size: 13px;
}

.utmSchoolAdmins .utmParticipants__tableWrap td strong {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-weight: 750;
}

@media (max-width: 900px) {
  .utmSchoolAdmins__headerTools,
  .utmSchoolAdmins__headerTools .gridModernSearch {
    width: 100%;
  }
}
.utmEligibleAddModal__events {
  display: grid;
  gap: 7px;
  max-height: 240px;
  margin-top: 14px;
  padding: 12px;
  overflow-y: auto;
  border: 1px solid #dbe4ee;
  border-radius: 10px;
  background: #f8fafc;
}

.utmEligibleAddModal__events > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 3px;
}

.utmEligibleAddModal__events > div:first-child span,
.utmEligibleAddModal__events p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
}

.utmEligibleAddModal__eventTools {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 2px 0 5px;
}

.utmEligibleAddModal__eventTools > label {
  display: flex;
  flex: 1 1 220px;
  align-items: center;
  gap: 7px;
  min-width: 0;
  height: 36px;
  margin: 0;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
}

.utmEligibleAddModal__eventTools > label input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
}

.utmEligibleAddModal__eventTools > div {
  display: inline-flex;
  gap: 6px;
}

.utmEligibleAddModal__eventTools button {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #227ebd;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.utmEligibleAddModal__eventTools button:hover:not(:disabled) {
  border-color: #227ebd;
  background: #eff8fc;
}

.utmEligibleAddModal__eventTools button:disabled {
  cursor: default;
  opacity: 0.45;
}

.utmEligibleAddModal__selectAll {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #344054;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.utmEligibleAddModal__selectAll input { position: absolute; opacity: 0; }
.utmEligibleAddModal__selectAll span { position: relative; width: 34px; height: 20px; border-radius: 999px; background: #cbd5e1; transition: background .15s ease; }
.utmEligibleAddModal__selectAll span::after { position: absolute; top: 3px; left: 3px; width: 14px; height: 14px; border-radius: 50%; background: #fff; content: ''; transition: transform .15s ease; }
.utmEligibleAddModal__selectAll input:checked + span { background: #227ebd; }
.utmEligibleAddModal__selectAll input:checked + span::after { transform: translateX(14px); }

.utmEligibleAddModal__events > label {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0;
  padding: 8px 9px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
}

.utmEligibleAddModal__events > label > span {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.utmEligibleAddModal__events > label small {
  color: #64748b;
  font-size: 11px;
  line-height: 1.45;
}

@media (max-width: 620px) {
  .utmEligibleAddModal__eventTools {
    align-items: stretch;
    flex-direction: column;
  }

  .utmEligibleAddModal__eventTools > label {
    flex-basis: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminSUView/Tournaments/Tournaments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iFAAiF;AACnF;AACA;EACE,kDAAkD;EAClD,gDAAgD;EAChD,WAAW;EACX,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,sCAAsC;EACtC,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,8CAA8C;EAC9C,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;;EAEE,eAAe;AACjB;;AAEA,8GAA8G;AAC9G;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;;EAEE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yCAAyC;EACzC,oBAAoB;EACpB,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,sDAAsD;EACtD,oCAAoC;AACtC;AACA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+CAA+C;EAC/C,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA,yCAAyC,eAAe,EAAE;AAC1D;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,uCAAuC;EACvC,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB;AACA;qEACqE,cAAc,EAAE;AACrF;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mEAAmE;EACnE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iFAAiF;AACnF;AACA;;;EAGE,qCAAqC;EACrC,mCAAmC;EACnC,4CAA4C;EAC5C,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iFAAiF;AACnF;AACA;;EAEE,uCAAuC;EACvC,qCAAqC;EACrC,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA,gCAAgC,kCAAkC,EAAE,qBAAqB,EAAE;AAC3F;EACE,qCAAqC;EACrC,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA,sCAAsC,kBAAkB,EAAE,iBAAiB,EAAE;;AAE7E;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,wCAAwC;EACxC,gCAAgC;EAChC,8FAA8F;AAChG;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;;;EAGE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;AAC9B;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;;;EAGE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;;;;EAIE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB;yBACuB;AACzB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE;yBACuB;AACzB;AACA;EACE;yBACuB;AACzB;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,oDAAoD;EACpD,gBAAgB;EAChB,qCAAqC;EACrC,wFAAwF;AAC1F;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,sDAAsD;AACxD;AACA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;AACA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;AACA;;;EAGE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,2CAA2C;EAC3C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wQAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;;;EAGE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;EACE,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oBAAoB;EACpB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,8EAA8E;EAC9E,yEAAyE;EACzE,uEAAuE;AACzE;AACA;EACE,6CAA6C;EAC7C,2CAA2C;EAC3C,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,kDAAkD;EAClD,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,gEAAgE;AAClE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,iDAAiD;EACjD,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0CAA0C;EAC1C,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kFAAkF;AACpF;;AAEA;;EAEE,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;AACb;;AAEA;;EAEE,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;AAC1D;AACA;;EAEE,6BAA6B;EAC7B,sDAAsD;EACtD,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,OAAO;EACP,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;EACrC,gEAAgE;AAClE;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sDAAsD;EACtD,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sDAAsD;EACtD,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;AACf;AACA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,gEAAgE;AAClE;AACA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,4CAA4C;AAC9C;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mEAAmE;AACrE;AACA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,gEAAgE;AAClE;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,0DAA0D;AAC5D;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;AACA;;EAEE,0BAA0B;EAC1B,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;EAC5B,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,kDAAkD;EAClD,gDAAgD;AAClD;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sDAAsD;AACxD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,OAAO;AACT;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mDAAmD;EACnD,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,OAAO;AACT;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;;EAEE,WAAW;AACb;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;AACA;EACE,OAAO;EACP,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gDAAgD;EAChD,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,gDAAgD;EAChD,0CAA0C;EAC1C,WAAW;AACb;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;;;IAGE,wBAAwB;IACxB,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,8QAA8Q;EAC9Q,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;;;;IAIE,WAAW;EACb;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,wCAAwC,kBAAkB,EAAE,UAAU,EAAE;AACxE,uCAAuC,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AACnK,8CAA8C,kBAAkB,EAAE,QAAQ,EAAE,SAAS,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,WAAW,EAAE,+BAA+B,EAAE;AACtM,uDAAuD,mBAAmB,EAAE;AAC5E,8DAA8D,2BAA2B,EAAE;;AAE3F;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".tournamentSummaryCard {\n  margin-top: 0;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  padding: 0 24px 24px 24px;\n}\n\n.GenericSummary.tournamentSummary {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.GenericSummary.tournamentSummary .GenericSummary__tabs {\n  flex: 0 0 auto;\n  padding: 20px 0 0 0;\n  background: #fff;\n}\n\n.GenericSummary.tournamentSummary .GenericSummary__content {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: visible;\n  padding: 0;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary {\n  display: flex;\n  align-items: flex-end;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin: 0 !important;\n  padding: 0 !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  list-style: none !important;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item {\n  display: block !important;\n  margin-bottom: 0 !important;\n  list-style: none !important;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item::marker {\n  content: none !important;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 10px 14px;\n  border: none !important;\n  border-radius: 10px 10px 0 0;\n  background: transparent;\n  color: #5b6875;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-decoration: none;\n  box-shadow: none !important;\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link:hover {\n  color: #1f2d3d;\n  background: rgba(23, 162, 184, 0.06);\n  text-decoration: none;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link:focus {\n  outline: none;\n  text-decoration: none;\n  box-shadow: inset 0 -2px 0 #17a2b8 !important;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link.active {\n  color: #0f6f7d !important;\n  background: #eef9fb !important;\n  border: none !important;\n  box-shadow: inset 0 -2px 0 #17a2b8 !important;\n}\n\n.tournamentSummaryActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 16px 0 14px 0;\n  margin-bottom: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.tournamentSummaryActions .btn,\n.tournamentSummaryActions button {\n  margin: 0 !important;\n}\n\n.tournamentSummaryActions:empty {\n  display: none;\n}\n\n.tournamentSummaryBody {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.tournamentSummaryHero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 14px 16px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 14px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.025), rgba(0, 0, 0, 0.01));\n}\n\n.tournamentSummaryHeroMain {\n  min-width: 0;\n  flex: 1 1 420px;\n}\n\n.tournamentSummaryTitle {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1.2;\n  color: #1f2d3d;\n}\n\n.tournamentSummaryDescription {\n  margin-top: 8px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #5b6875;\n}\n\n.tournamentSummaryDescription p:last-child {\n  margin-bottom: 0;\n}\n\n.tournamentSummaryDescription--muted {\n  color: #8a94a1;\n}\n\n.tournamentSummaryHeroSide {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex: 0 0 auto;\n}\n\n.tournamentSummaryPill {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #0f6f7d;\n  background: #e8f8fb;\n  border: 1px solid rgba(23, 162, 184, 0.18);\n}\n\n.tournamentSummaryPill--subtle {\n  color: #4b5563;\n  background: rgba(0, 0, 0, 0.04);\n  border-color: rgba(0, 0, 0, 0.08);\n}\n\n.tournamentSummaryGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n@media (max-width: 1100px) {\n  .tournamentSummaryGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.tournamentSummaryItem {\n  padding: 12px 14px;\n  border: 1px solid rgba(0, 0, 0, 0.07);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.tournamentSummaryItemLabel {\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #8b96a3;\n}\n\n.tournamentSummaryItemValue {\n  margin-top: 8px;\n  font-size: 16px;\n  line-height: 1.45;\n  color: #233142;\n  word-break: break-word;\n}\n\n@media (max-width: 900px) {\n  .tournamentSummaryGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.tournamentSummaryInlineGroups {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.tournamentSummaryInlineGroup {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  min-width: 0;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.025);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.tournamentSummaryInlineGroupLabel {\n  flex: 0 0 auto;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #7b8794;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.tournamentSummaryInlineGroupValue {\n  min-width: 0;\n  font-size: 13px;\n  line-height: 1.35;\n  color: #1f2d3d;\n  word-break: break-word;\n}\n\n.tournamentAutoEnrollmentKpis {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.tournamentAutoEnrollmentKpi {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: #fff;\n}\n\n.tournamentAutoEnrollmentKpiLabel {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.tournamentAutoEnrollmentKpiValue {\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.1;\n  color: #1f2d3d;\n}\n\n@media (max-width: 900px) {\n  .tournamentAutoEnrollmentKpis {\n    grid-template-columns: 1fr;\n  }\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary {\n  row-gap: 2px;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item {\n  margin-top: 0 !important;\n}\n\n.GenericSummary.tournamentSummary .nav.nav-tabs.tournamentSummary > .nav-item > .nav-link {\n  min-height: 38px;\n  padding: 8px 14px;\n}\n\n.GenericSummary.tournamentSummary .GenericSummary__tabs {\n  margin-bottom: 2px;\n}\n\n.tAeSwitchGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px 18px;\n  margin-bottom: 18px;\n}\n\n.tAeSwitchItem {\n  margin: 0 !important;\n  padding: 12px 14px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  background: #fff;\n}\n\n@media (max-width: 900px) {\n  .tAeSwitchGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.tAeFooter {\n  padding: 12px 0 0 0 !important;\n  margin-top: 18px;\n  background: transparent !important;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.tAeFooter .btn,\n.tAeFooter button {\n  min-width: 108px;\n}\n\n.tournamentSummaryLinkStack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.tournamentSummaryLinkStack .tournamentSummaryInlineGroup {\n  max-width: 100%;\n}\n\n.tournamentSummaryLinkStack .tournamentSummaryInlineGroupValue {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.tournamentSummaryPill--yes,\n.tournamentSummaryPill--enabled {\n  color: #166534;\n  background: #dcfce7;\n  border-color: #bbf7d0;\n}\n\n.tournamentSummaryPill--no,\n.tournamentSummaryPill--disabled {\n  color: #6b7280;\n  background: #f3f4f6;\n  border-color: #e5e7eb;\n}\n\n/* Upcoming / archive tournament lists */\n.unionTournamentsModern {\n  width: 100%;\n  min-width: 0;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.unionTournamentsHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 0 0 12px;\n}\n.unionTournamentsHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n}\n.unionTournamentsAdd {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 14px;\n  border: 1px solid var(--brand-600, #227ebd);\n  border-radius: 9px;\n  background: var(--brand-600, #227ebd);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 750;\n  box-shadow: none;\n  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.unionTournamentsAdd:hover {\n  border-color: var(--action-primary-hover, #1a6da3);\n  background: var(--action-primary-hover, #1a6da3);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.2);\n}\n.unionTournamentsTabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 12px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n.unionTournamentsTabs button {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  gap: 8px;\n  padding: 0 15px;\n  border: 0;\n  border-bottom: 2.5px solid transparent;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  font-weight: 650;\n}\n.unionTournamentsTabs button.isActive {\n  border-bottom-color: var(--brand-600, #227ebd);\n  color: var(--text-strong, #0f172a);\n  font-weight: 750;\n}\n.unionTournamentsTabs span {\n  display: inline-flex;\n  min-width: 20px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef7fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11.5px;\n}\n\n/* Shell & Header — Direction B, organiser-side tournament lists. */\n.unionTournamentsPageHeader {\n  height: 70px;\n  min-width: 0;\n  margin: -20px -30px 18px -22px;\n  padding: 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.unionTournamentsModern.unionTournamentsListShell,\n.schoolInvitesHub.unionTournamentsListShell {\n  max-width: none;\n}\n\n/* Escape both nested content gutters so the page header reaches from the sidebar edge to the viewport edge. */\n.unionTournamentsPage .unionTournamentsPageHeader {\n  width: calc(100% + 100px);\n  margin: -40px 0 18px -28px;\n}\n\n.schoolInvitesHub.unionTournamentsListShell {\n  box-sizing: border-box;\n  padding-right: 4px;\n  padding-left: 4px;\n}\n\n.schoolInvitesHub.unionTournamentsListShell .unionTournamentsPageHeader {\n  width: calc(100% + 56px);\n  margin: -38px 0 18px -28px;\n}\n\n.unionTournamentsPageHeader h1 {\n  flex: 0 0 auto;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.015em;\n  white-space: nowrap;\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 auto;\n  align-self: stretch;\n  align-items: stretch;\n  gap: 26px;\n  overflow-x: auto;\n  margin: 0;\n  border-bottom: 0;\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs button {\n  position: relative;\n  height: auto;\n  flex: 0 0 auto;\n  padding: 1px 0 0;\n  border: 0;\n  color: var(--text-muted, #64748b);\n  font-size: 15px;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs button::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: transparent;\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs button:hover {\n  color: var(--text-strong, #0f172a);\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs button.isActive {\n  color: var(--blue-600, #1a6da3);\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs button.isActive::after {\n  background: var(--blue-500, #227ebd);\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs span {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs button.isActive span {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs span.unionTournamentsUnreadCount,\n.unionTournamentsPageHeader .unionTournamentsTabs button.isActive span.unionTournamentsUnreadCount {\n  background: var(--amber-100, #ffedc2);\n  color: var(--amber-800, #8a4b08);\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart {\n  display: inline-flex;\n  min-width: auto;\n  height: 32px;\n  flex: 0 0 auto;\n  align-self: center;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--amber-100, #ffe9c2);\n  border-radius: 999px;\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart b {\n  color: inherit;\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 13px;\n  font-weight: 850;\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert {\n  display: inline-flex;\n  min-width: auto;\n  height: 32px;\n  flex: 0 0 auto;\n  align-self: center;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--red-100, #f9d4d9);\n  border-radius: 999px;\n  background: var(--red-50, #fdecee);\n  color: var(--red-700, #a52836);\n  font-size: 12px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert b {\n  color: inherit;\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 13px;\n  font-weight: 850;\n}\n\n.unionTournamentsPageHeader .unionTournamentsAdd {\n  height: 40px;\n  flex: 0 0 auto;\n  border-radius: var(--radius-md, 8px);\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.unionTournamentsSummaryStrip {\n  display: flex;\n  width: calc(100% + 56px);\n  min-height: 58px;\n  align-items: center;\n  gap: 10px;\n  margin: -18px 0 18px -28px;\n  padding: 14px 72px 14px 28px;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n.unionTournamentsSummaryStrip > button,\n.unionTournamentsSummaryStrip > span {\n  display: inline-flex;\n  min-width: max-content;\n  min-height: 32px;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 650;\n}\n.unionTournamentsSummaryStrip > button { cursor: pointer; }\n.unionTournamentsSummaryStrip b {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 15px;\n  font-weight: 800;\n}\n.unionTournamentsSummaryStrip .unionTournamentsNextStart,\n.unionTournamentsSummaryStrip .unionTournamentsConfirmationAlert {\n  border-color: var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n  cursor: pointer;\n}\n.unionTournamentsSummaryStrip .unionTournamentsNextStart b,\n.unionTournamentsSummaryStrip .unionTournamentsConfirmationAlert b { color: inherit; }\n.unionTournamentsSummaryStrip .unionTournamentsSummaryContext {\n  margin-left: auto;\n  cursor: default;\n}\n.schoolInvitesHub.unionTournamentsListShell .unionTournamentsSummaryStrip {\n  width: calc(100% + 56px);\n  margin-left: -28px;\n}\n\n.unionTournamentsModern .unionTournamentsListCard {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n}\n\n.unionTournamentsModern .unionTournamentsListCard .gridPanelTitleRow {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.unionTournamentsModern .unionTournamentsListCard .gridPanelTitle {\n  padding: 0 !important;\n}\n\n.unionTournamentsModern .unionTournamentsListCard .gridPanelTitle > h1 {\n  margin: 0 10px 0 0;\n  color: var(--text-muted, #64748b);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 40px;\n}\n\n.unionTournamentsModern .unionTournamentsListCard .gridModernFilterButton,\n.unionTournamentsModern .unionTournamentsListCard .gridModernColumns > button,\n.unionTournamentsModern .unionTournamentsListCard .unionTournamentsReportsButton {\n  height: 32px;\n  border-radius: 7px;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n@media (max-width: 900px) {\n  .unionTournamentsPageHeader {\n    height: auto;\n    min-height: 70px;\n    flex-wrap: wrap;\n    gap: 0 16px;\n    padding-top: 10px;\n  }\n  .unionTournamentsPageHeader .unionTournamentsTabs {\n    width: 100%;\n    height: 42px;\n    flex-basis: 100%;\n    order: 3;\n  }\n  .unionTournamentsPageHeader .unionTournamentsAdd {\n    margin-left: auto;\n  }\n}\n\n@media (max-width: 1217px) {\n  .unionTournamentsPage {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .unionTournamentsPage .unionTournamentsPageHeader {\n    width: 100vw;\n    margin-top: -36px;\n    margin-left: -28px;\n  }\n\n  .schoolInvitesHub.unionTournamentsListShell {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .schoolInvitesHub.unionTournamentsListShell .unionTournamentsPageHeader {\n    width: 100vw;\n    margin-top: -34px;\n    margin-left: -28px;\n  }\n\n  .unionTournamentsSummaryStrip,\n  .schoolInvitesHub.unionTournamentsListShell .unionTournamentsSummaryStrip {\n    width: 100vw;\n    margin-left: -28px;\n    padding-right: 28px;\n  }\n}\n\n.utListTournament {\n  display: flex;\n  min-width: 260px;\n  flex-direction: column;\n  gap: 3px;\n}\n.utListTournament__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  color: var(--text-strong, #0f172a);\n  font-size: 13.5px;\n  font-weight: 750;\n  line-height: 1.3;\n}\n.utListTournament__meta {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  white-space: nowrap;\n}\n.utListTournament__meta i {\n  width: 9px;\n  height: 9px;\n  flex: 0 0 9px;\n  border-radius: 2px;\n}\n.utListTournament__meta b {\n  color: var(--text-subtle, #94a3b8);\n}\n.utListDate {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  white-space: nowrap;\n}\n.utListDate strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 650;\n}\n.utListDate span {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n}\n.utListCapacity {\n  display: flex;\n  min-width: 120px;\n  justify-content: space-between;\n  color: var(--text-strong, #0f172a);\n  font-size: 12.5px;\n}\n.utListCapacityBar {\n  height: 5px;\n  margin-top: 5px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: var(--slate-100, #f1f5f9);\n}\n.utListCapacityBar i {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--brand-500, #368fca);\n}\n.utListCapacityBar.is-nearly-full i {\n  background: var(--amber-500, #e5a21a);\n}\n.utListCapacityBar.is-full i {\n  background: var(--red-500, #dc4c64);\n}\n.utListBadge {\n  display: inline-flex;\n  min-height: 23px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.utListBadge.is-warning {\n  background: var(--amber-50, #fff8e8);\n  color: var(--amber-700, #805b16);\n}\n.utListBadge.is-success {\n  background: var(--green-50, #edf8f1);\n  color: var(--green-700, #287a50);\n}\n.utListBadge.is-neutral {\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n.utListBadge.is-info {\n  background: var(--blue-50, #eef7fc);\n  color: var(--blue-700, #155d8c);\n}\n.utListBadge.has-dot::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.utListCentered {\n  text-align: center;\n}\n.utListMuted {\n  color: var(--text-subtle, #94a3b8);\n}\n.utListWaitingCount {\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 700;\n}\n.utListWaitingCount.has-items {\n  color: var(--amber-700, #805b16);\n}\n.utListBoolean {\n  display: inline-flex;\n  width: 22px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-subtle, #94a3b8);\n  font-weight: 800;\n}\n.utListBoolean.is-yes {\n  background: var(--green-50, #edf8f1);\n  color: var(--green-700, #287a50);\n}\n.utListTags {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n.utListTags > span:not(.utListMuted) {\n  display: inline-flex;\n  height: 21px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 11px;\n  font-weight: 650;\n}\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert.is-clickable {\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert.is-clickable:hover,\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert.is-clickable:focus-visible,\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert.is-active {\n  border-color: var(--red-300, #e7a2ab);\n  background: var(--red-100, #f9d4d9);\n  box-shadow: 0 0 0 3px rgba(165, 40, 54, 0.1);\n  outline: none;\n}\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsConfirmationAlert i {\n  display: inline-flex;\n  width: 17px;\n  height: 17px;\n  align-items: center;\n  justify-content: center;\n  margin-left: 2px;\n  border-radius: 50%;\n  background: rgba(165, 40, 54, 0.1);\n  font-size: 14px;\n  font-style: normal;\n  line-height: 1;\n}\n\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart.is-clickable {\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart.is-clickable:hover,\n.unionTournamentsPageHeader .unionTournamentsTabs .unionTournamentsNextStart.is-clickable:focus-visible {\n  border-color: var(--amber-300, #f2c46d);\n  background: var(--amber-100, #ffedc7);\n  box-shadow: 0 0 0 3px rgba(229, 162, 26, 0.14);\n  outline: none;\n}\n\n.unionInvitesSegments {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 2px;\n  padding: 3px;\n  border-radius: 9px;\n  background: var(--surface-sunken, #f1f5f9);\n}\n.unionInvitesSegments a {\n  display: inline-flex;\n  min-height: 32px;\n  align-items: center;\n  padding: 7px 14px;\n  border-radius: 6px;\n  color: var(--text-muted, #64748b);\n  font-size: 13.5px;\n  font-weight: 650;\n  line-height: 1;\n  text-decoration: none;\n}\n.unionInvitesSegments a:hover { color: var(--text-strong, #0f172a); text-decoration: none; }\n.unionInvitesSegments a.is-active {\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.14);\n}\n.utListTags > span:not(.utListMuted) > em {\n  overflow: hidden;\n  max-width: 132px;\n  font-style: normal;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.utListTags > span:not(.utListMuted) > i {\n  width: 6px;\n  height: 6px;\n  flex: 0 0 6px;\n  border-radius: 50%;\n}\n.utListFlag {\n  display: inline-flex;\n  color: var(--amber-600, #c98312);\n}\n.utListFlag svg {\n  width: 15px;\n  height: 15px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.unionTournamentsModern table.table tbody tr {\n  height: 56px;\n  cursor: pointer;\n}\n.unionTournamentsModern table.table tbody tr > td:last-child {\n  position: relative;\n  padding-right: 40px;\n}\n.unionTournamentsModern table.table tbody tr > td:last-child::after {\n  content: '›';\n  position: absolute;\n  top: 50%;\n  right: 14px;\n  transform: translateY(-50%);\n  color: var(--text-subtle, #94a3b8);\n  font-size: 22px;\n  line-height: 1;\n  opacity: 0;\n  transition: opacity 0.14s ease;\n}\n.unionTournamentsModern table.table tbody tr:hover > td:last-child::after {\n  opacity: 1;\n}\n.utListStateIcon {\n  display: inline-flex;\n  width: 22px;\n  height: 22px;\n  flex: 0 0 22px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n}\n.utListStateIcon svg {\n  width: 14px;\n  height: 14px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.utListStateIcon.is-published {\n  background: var(--green-50, #edf8f1);\n  color: var(--green-700, #287a50);\n}\n.utListStateIcon.is-highlighted {\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n.utListStateIcon.is-highlighted svg { fill: currentColor; stroke-width: 1.4; }\n\n.unionTournamentsModern .gridPanelModern {\n  margin-bottom: 12px;\n}\n.unionTournamentsPage {\n  min-height: calc(100vh - 76px);\n  padding: 20px 72px 32px 4px;\n  background: var(--surface-page, #f5f7fb);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n.unionTournamentsPage > .row {\n  margin: 0;\n}\n.unionTournamentsPage > .row > [class*='col-'] {\n  padding: 0;\n}\n.unionTournamentsModern {\n  width: 100%;\n  max-width: 1280px;\n}\n.unionTournamentsModern button,\n.unionTournamentsModern input,\n.unionTournamentsModern select {\n  font-family: inherit;\n}\n.unionTournamentsModern button {\n  cursor: pointer;\n  text-transform: none;\n}\n.unionTournamentsModern > .container-fluid {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n}\n.unionTournamentsModern .gridPanelTitleRow {\n  margin: 0;\n}\n.unionTournamentsModern .gridPanelTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 0 12px !important;\n}\n.unionTournamentsModern .gridPanelTitle > h1 {\n  order: 0;\n  margin: 0 10px 0 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 40px;\n  white-space: nowrap;\n}\n.unionTournamentsModern .gridPanelTitle > h1 + span {\n  order: 0;\n  display: inline-flex;\n  min-width: 25px;\n  height: 23px;\n  align-items: center;\n  justify-content: center;\n  margin-right: 4px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11px;\n  font-weight: 800;\n}\n.unionTournamentsModern .table {\n  margin-top: 0 !important;\n}\n\n.unionTournamentsModern .gridModernToolbar {\n  align-items: flex-end;\n}\n\n.unionTournamentsModern .gridModernSearch {\n  order: 1;\n  display: inline-flex;\n  width: min(360px, 100%);\n  height: 40px;\n  align-items: center;\n  margin: 0;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  box-shadow: none;\n}\n.unionTournamentsModern .gridModernSearch:focus-within {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n.unionTournamentsModern .gridModernSearch input {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n}\n.unionTournamentsModern .gridModernSearch__clear {\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 20px;\n  line-height: 1;\n}\n.unionTournamentsModern .gridModernSearch__clear:hover {\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.unionTournamentsModern .gridModernFiltersAnchor,\n.unionTournamentsModern .gridModernColumns {\n  position: relative;\n  flex: 0 0 auto;\n}\n.unionTournamentsModern .gridModernFiltersAnchor {\n  order: 2;\n}\n.unionTournamentsModern .gridModernColumns {\n  order: 3;\n}\n.unionTournamentsModern .gridModernAdditionalOptions {\n  order: 4;\n}\n.unionTournamentsModern .gridModernFilterButton,\n.unionTournamentsModern .gridModernColumns > button,\n.unionTournamentsReportsButton {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  margin: 0;\n  padding: 0 13px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  box-shadow: none;\n  font-size: 13px;\n  font-weight: 700;\n}\n.unionTournamentsModern .gridModernFilterButton:hover,\n.unionTournamentsModern .gridModernFilterButton.is-active,\n.unionTournamentsModern .gridModernColumns > button:hover,\n.unionTournamentsReportsButton:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n.unionTournamentsReportsButton::before {\n  content: '';\n  width: 16px;\n  height: 16px;\n  background: currentColor;\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 4h14v16H5zM8 8h8M8 12h8M8 16h5' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")\n    center/16px no-repeat;\n}\n.unionTournamentsModern .gridModernFilterButton > span,\n.unionTournamentsModern .gridModernColumns > button > span {\n  width: 16px;\n  height: 16px;\n  background: currentColor;\n}\n.unionTournamentsModern .gridModernFilterButton > span {\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\")\n    center/16px no-repeat;\n}\n.unionTournamentsModern .gridModernColumns > button > span {\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\")\n    center/16px no-repeat;\n}\n.unionTournamentsModern .gridModernFilterButton b,\n.unionTournamentsModern .gridModernColumns > button b {\n  display: inline-flex;\n  min-width: 19px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 10.5px;\n}\n.unionTournamentsModern .gridModernFilterButton.is-active b {\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.unionTournamentsModern .gridModernFilterPopover {\n  position: fixed;\n  z-index: 2147483001;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  flex-direction: column;\n  margin: 0;\n  border: 0;\n  border-left: 1px solid var(--border-subtle, #d9e2ec);\n  border-radius: 0;\n  background: var(--surface-card, #fff);\n  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n.unionTournamentsModern .gridModernFilterPopover > header {\n  display: flex;\n  min-height: 34px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  margin: 18px 18px 0;\n  padding: 0 0 12px;\n  border-bottom: 1px solid var(--border-subtle, #e6ebf1);\n}\n.unionTournamentsModern .gridModernFilterPopover > header strong {\n  color: var(--text-strong, #172b4d);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 16px;\n  font-weight: 800;\n}\n.unionTournamentsModern .gridModernFilterPopover > header button {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: var(--radius-md, 8px);\n  background: transparent;\n  color: var(--text-muted, #667085);\n  font-size: 23px;\n  line-height: 1;\n}\n.unionTournamentsModern .gridModernFilterPopover > header button:hover {\n  background: var(--surface-hover, #f2f6fa);\n  color: var(--text-strong, #172b4d);\n}\n.unionTournamentsModern .gridModernFilterPopover__fields {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 18px;\n  padding: 18px 18px 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.unionTournamentsModern .gridModernFilterPopover__fields > label {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 7px;\n  margin: 0;\n}\n.unionTournamentsModern .gridModernFilterPopover__fields > label > span,\n.unionTournamentsModern .gridModernFilterPopover .gridModernFilterChips legend,\n.unionTournamentsModern .gridModernFilterPopover .sit-dp__label {\n  margin: 0;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n.unionTournamentsModern .gridModernFilterPopover__fields input,\n.unionTournamentsModern .gridModernFilterPopover__fields select,\n.unionTournamentsModern .gridModernFilterPopover .sit-dp__trigger {\n  width: 100%;\n  min-height: 40px;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background-color: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  box-shadow: none;\n}\n.unionTournamentsModern .gridModernFilterPopover__fields select {\n  padding-right: 32px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n}\n.unionTournamentsModern .gridModernFilterPopover__fields input:focus,\n.unionTournamentsModern .gridModernFilterPopover__fields select:focus,\n.unionTournamentsModern .gridModernFilterPopover .sit-dp__trigger:focus-within {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));\n}\n.unionTournamentsModern .gridModernFilterChips {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.unionTournamentsModern .gridModernFilterChips > div {\n  display: flex;\n  gap: 7px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n.unionTournamentsModern .gridModernFilterChips button {\n  min-height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 650;\n}\n.unionTournamentsModern .gridModernFilterChips button:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n}\n.unionTournamentsModern .gridModernFilterChips button.is-selected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.unionTournamentsModern .gridModernFilterChips button.has-option-color {\n  border-color: color-mix(in srgb, var(--grid-filter-option-color) 52%, #cbd5e1);\n  background: color-mix(in srgb, var(--grid-filter-option-color) 12%, #fff);\n  color: color-mix(in srgb, var(--grid-filter-option-color) 78%, #0f172a);\n}\n.unionTournamentsModern .gridModernFilterChips button.has-option-color.is-selected {\n  border-color: var(--grid-filter-option-color);\n  background: var(--grid-filter-option-color);\n  color: #fff;\n}\n.unionTournamentsModern .gridModernFilterPopover > footer {\n  display: flex;\n  min-height: 69px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 14px 18px;\n  border-top: 1px solid var(--border-subtle, #e6ebf1);\n  background: var(--surface-card, #fff);\n}\n.unionTournamentsModern .gridModernFilterPopover > footer > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.unionTournamentsModern .gridModernFilterPopover > footer button {\n  min-height: 38px;\n  padding: 0 13px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 700;\n}\n.unionTournamentsModern .gridModernFilterPopover > footer button.is-clear {\n  padding: 0;\n  border-color: transparent;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n}\n.unionTournamentsModern .gridModernFilterPopover > footer button.is-apply {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.unionTournamentsModern .gridModernFilterPopover > footer button.is-apply:hover {\n  border-color: var(--action-primary-hover, #1a6da3);\n  background: var(--action-primary-hover, #1a6da3);\n}\n.unionTournamentsModern .gridModernFilterPopover .sit-dp__pop {\n  position: fixed;\n  z-index: 2147483002;\n  top: 50%;\n  left: 50%;\n  right: auto;\n  transform: translate(-50%, -50%);\n}\n.unionTournamentsModern .gridModernColumns__menu {\n  position: absolute;\n  top: 46px;\n  right: 0;\n  z-index: 1070;\n  width: 260px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-lg, 0 18px 40px rgba(15, 23, 42, 0.16));\n}\n.unionTournamentsModern .gridModernColumns__menu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 8px 9px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n.unionTournamentsModern .gridModernColumns__menu header button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font-size: 12px;\n  font-weight: 700;\n}\n.unionTournamentsModern .gridModernColumns__menu label {\n  display: flex;\n  min-height: 34px;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  padding: 7px 8px;\n  border-radius: var(--radius-sm, 6px);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 600;\n}\n.unionTournamentsModern .gridModernColumns__menu label:hover {\n  background: var(--surface-hover, #f8fafc);\n}\n.unionTournamentsModern .gridModernColumns__menu input,\n.unionTournamentsModern table input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.unionTournamentsModern table .custom-checkbox input[type='checkbox'] {\n  position: relative;\n  display: block;\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  border: 1.5px solid var(--border-strong, #aebaca);\n  border-radius: 4px;\n  background: var(--surface-card, #fff);\n  box-shadow: none;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.unionTournamentsModern table .custom-checkbox input[type='checkbox']:hover {\n  border-color: var(--action-primary, #227ebd);\n}\n\n.unionTournamentsModern table .custom-checkbox input[type='checkbox']:focus-visible {\n  border-color: var(--action-primary, #227ebd);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.18);\n}\n\n.unionTournamentsModern table .custom-checkbox input[type='checkbox']:checked {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n\n.unionTournamentsModern table .custom-checkbox input[type='checkbox']:checked::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 5px;\n  width: 4px;\n  height: 8px;\n  border: solid #fff;\n  border-width: 0 1.5px 1.5px 0;\n  transform: rotate(45deg);\n}\n\n.unionTournamentsModern table .custom-checkbox input[type='checkbox']:disabled {\n  border-color: var(--border-subtle, #dbe3ec);\n  background: var(--surface-disabled, #f1f5f9);\n  cursor: not-allowed;\n  opacity: 0.75;\n}\n\n.unionTournamentsModern .gridTableActions {\n  display: flex;\n  min-height: 0;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  padding: 8px 14px;\n  flex-wrap: wrap;\n  border: 1px solid var(--blue-100, #cfe5f2);\n  border-radius: var(--radius-md, 8px);\n  background: var(--blue-50, #eef6fc);\n  box-shadow: none;\n}\n.unionTournamentsModern .gridTableActions > span {\n  margin-right: 4px;\n  color: var(--blue-700, #155d8c);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.unionTournamentsModern .gridTableActions > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.unionTournamentsModern .gridTableActions button {\n  display: inline-flex;\n  height: 32px;\n  min-height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 10px;\n  background: #fff;\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n}\n\n.unionTournamentsModern .gridTableActions button:hover,\n.unionTournamentsModern .gridTableActions button:focus-visible {\n  border-color: var(--blue-300, #8fc4e3);\n  background: var(--blue-50, #eef7fc);\n  color: var(--blue-700, #155d8c);\n  outline: none;\n}\n\n.unionTournamentsModern .gridTableActions button.is-danger {\n  border-color: var(--red-600, #dc2626);\n  background: var(--red-600, #dc2626);\n  color: #fff;\n}\n\n.unionTournamentsModern .gridTableActions button.is-danger:hover,\n.unionTournamentsModern .gridTableActions button.is-danger:focus-visible {\n  border-color: var(--red-700, #b91c1c);\n  background: var(--red-700, #b91c1c);\n  color: #fff;\n}\n\n.unionTournamentsModern .table-responsive {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 0;\n  background: #fff;\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n\n.unionTournamentDeleteModal .modal-content {\n  border: 1px solid var(--border-subtle, #dbe3ec) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 20px 54px rgba(15, 23, 42, 0.2) !important;\n}\n.unionTournamentDeleteModal .modal-header,\n.unionTournamentDeleteModal .modal-footer {\n  padding: 16px 20px !important;\n  border-color: var(--border-subtle, #dbe3ec) !important;\n  background: #fff !important;\n}\n.unionTournamentDeleteModal .modal-body {\n  padding: 20px !important;\n}\n.unionTournamentDeleteModal__body {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n.unionTournamentDeleteModal__icon {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #fecdd3;\n  border-radius: 11px;\n  background: #fff1f2;\n  color: #be123c;\n}\n.unionTournamentDeleteModal__icon svg {\n  width: 22px;\n  height: 22px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n.unionTournamentDeleteModal__copy {\n  min-width: 0;\n  flex: 1;\n  color: var(--text-muted, #69778a);\n  font-size: 13px;\n}\n.unionTournamentDeleteModal__copy > strong {\n  color: var(--text-strong, #142033);\n  font-weight: 760;\n}\n.unionTournamentDeleteModal__copy p {\n  margin: 5px 0 0;\n  line-height: 1.5;\n}\n.unionTournamentDeleteModal__blocker {\n  margin-top: 9px;\n  padding: 9px 11px;\n  border: 1px solid #fecdd3;\n  border-radius: 8px;\n  background: #fff7f8;\n}\n.unionTournamentDeleteModal__blocker b {\n  display: block;\n  color: var(--text-strong, #142033);\n}\n.unionTournamentDeleteModal__blocker ul {\n  margin: 6px 0 0;\n  padding-left: 18px;\n  color: #9f1239;\n  line-height: 1.45;\n}\n.unionTournamentDeleteModal__blocker li + li {\n  margin-top: 3px;\n}\n.unionTournamentDeleteModal .modal-footer .btn-primary {\n  border-color: #be123c !important;\n  background: #be123c !important;\n  color: #fff !important;\n}\n.unionTournamentDeleteModal .modal-footer .btn-primary:hover {\n  border-color: #9f1239 !important;\n  background: #9f1239 !important;\n}\n.unionTournamentsModern table.table {\n  width: 100%;\n  margin: 0 !important;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.unionTournamentsModern .selectAllCheckbox .eSelectAllCheckbox {\n  z-index: 1080;\n  min-width: 190px;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-lg, 0 18px 40px rgba(15, 23, 42, 0.16));\n}\n.unionTournamentsModern .selectAllCheckbox .dropdown-item {\n  padding: 8px 10px;\n  border-radius: var(--radius-sm, 6px);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 600;\n}\n.unionTournamentsModern .selectAllCheckbox .dropdown-item:hover {\n  background: var(--surface-hover, #f8fafc);\n  color: var(--text-strong, #0f172a);\n}\n.unionTournamentsModern table.table th {\n  padding: 11px 14px;\n  border-top: 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.unionTournamentsModern table.table td {\n  padding: 12px 14px;\n  border-top: 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  vertical-align: middle;\n}\n.unionTournamentsModern table.table tbody tr,\n.unionTournamentsModern table.table tbody tr > td {\n  transform: none !important;\n  box-shadow: none !important;\n  transition: background 0.12s ease;\n}\n.unionTournamentsModern table.table tbody tr:hover,\n.unionTournamentsModern table.table tbody tr:hover > td {\n  background: var(--surface-hover, #f8fafc);\n}\n.unionTournamentsModern table.table tbody tr.table-primary,\n.unionTournamentsModern table.table tbody tr.table-primary > td {\n  background: var(--blue-50, #eef6fc) !important;\n}\n.unionTournamentsModern .gridActiveFilters {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n  padding: 0 0 12px;\n}\n.unionTournamentsModern .gridActiveFilters > span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n}\n\n.unionTournamentsModern .gridActiveFilters > span > button {\n  display: inline-flex;\n  width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  margin: 0 -3px 0 2px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: currentColor;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.unionTournamentsModern .gridActiveFilters > span > button:hover,\n.unionTournamentsModern .gridActiveFilters > span > button:focus-visible {\n  background: rgba(21, 93, 140, 0.12);\n  outline: none;\n}\n.unionTournamentsModern .gridActiveFilters > button {\n  padding: 0 4px;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font-size: 12px;\n  font-weight: 700;\n}\n.unionTournamentsModern .gridModernPagination {\n  margin: 12px 0 0;\n  padding-bottom: 14px;\n}\n@media (max-width: 900px) {\n  .unionTournamentsPage {\n    padding-right: 4px;\n  }\n}\n\n.utmEligible__removeError {\n  margin-top: 14px;\n  padding: 11px 12px;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  background: #fef2f2;\n  color: #991b1b;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.utmEligibleActionModal .modal-content {\n  border: 0 !important;\n}\n\n.utmEligibleActionModal__body {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.utmEligibleActionModal__icon {\n  display: grid;\n  flex: 0 0 44px;\n  width: 44px;\n  height: 44px;\n  place-items: center;\n  border-radius: 12px;\n  background: #eaf5fb;\n  color: #1777a8;\n}\n\n.utmEligibleActionModal__icon svg {\n  width: 22px;\n  height: 22px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-width: 2;\n}\n\n.utmEligibleActionModal__copy {\n  min-width: 0;\n}\n\n.utmEligibleActionModal__copy > strong {\n  color: #17243a;\n  font-size: 15px;\n}\n\n.utmEligibleActionModal__copy p {\n  margin: 7px 0 0;\n  color: #64748b;\n}\n\n.utmEligibleAddModal {\n  width: min(520px, calc(100vw - 40px));\n  overflow: hidden;\n  border: 1px solid #dbe4ee;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 24px 65px rgba(15, 23, 42, 0.24);\n}\n\n.utmEligibleAddModal__header {\n  display: grid;\n  grid-template-columns: 42px minmax(0, 1fr) 34px;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 20px;\n  border-bottom: 1px solid #e8edf3;\n  background: #f8fafc;\n}\n\n.utmEligibleAddModal__headingIcon {\n  display: grid;\n  width: 42px;\n  height: 42px;\n  place-items: center;\n  border-radius: 11px;\n  background: #e8f4fb;\n  color: #176f9f;\n}\n\n.utmEligibleAddModal__headingIcon svg {\n  width: 22px;\n  height: 22px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.9;\n}\n\n.utmEligibleAddModal__header h2 {\n  margin: 0;\n  color: #17243a;\n  font-size: 18px;\n  font-weight: 750;\n  line-height: 1.25;\n}\n\n.utmEligibleAddModal__header p {\n  margin: 3px 0 0;\n  color: #718096;\n  font-size: 12px;\n}\n\n.utmEligibleAddModal__header > button {\n  display: grid;\n  width: 34px;\n  height: 34px;\n  place-items: center;\n  padding: 0 0 2px;\n  border: 1px solid #dbe4ee;\n  border-radius: 9px;\n  background: #fff;\n  color: #64748b;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.utmEligibleAddModal__body {\n  padding: 18px 20px 20px;\n}\n\n.utmEligibleAddModal__summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 9px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.utmEligibleAddModal__summary b {\n  display: grid;\n  min-width: 24px;\n  height: 24px;\n  place-items: center;\n  border-radius: 999px;\n  background: #e8f4fb;\n  color: #176f9f;\n  font-size: 12px;\n}\n\n.utmEligibleAddModal__schools {\n  overflow: auto;\n  max-height: 190px;\n  border: 1px solid #e2e8f0;\n  border-radius: 11px;\n}\n\n.utmEligibleAddModal__schools > div {\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n}\n\n.utmEligibleAddModal__schools > div + div {\n  border-top: 1px solid #edf1f5;\n}\n\n.utmEligibleAddModal__schools > div > span {\n  display: grid;\n  flex: 0 0 30px;\n  width: 30px;\n  height: 30px;\n  place-items: center;\n  border-radius: 8px;\n  background: #eef2f7;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.utmEligibleAddModal__schools > div > span img {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.utmParticipants__schoolLogo,\n.utmWaitingList__school > span {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: #fff;\n}\n\n.utmParticipants__schoolLogo img,\n.utmWaitingList__school > span img {\n  width: 100%;\n  height: 100%;\n  padding: 2px;\n  object-fit: contain;\n}\n\n.utmEligibleAddModal__schools strong {\n  color: #27364c;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.utmEligibleAddModal__notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 12px;\n  padding: 10px 11px;\n  border-radius: 9px;\n  background: #f1f7fb;\n  color: #45657a;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.utmEligibleAddModal__notice svg {\n  flex: 0 0 auto;\n  margin-top: 1px;\n  fill: none;\n  stroke: #287da8;\n  stroke-width: 1.8;\n}\n\n.utmEligibleAddModal__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  padding: 14px 20px;\n  border-top: 1px solid #e8edf3;\n  background: #f8fafc;\n}\n\n.utmEligibleAddModal__footer button {\n  min-height: 38px;\n  padding: 0 15px;\n  border: 1px solid #d6dee8;\n  border-radius: 9px;\n  background: #fff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.utmEligibleAddModal__footer button.is-primary {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.utmEligibleAddModal button:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n.unionTournamentsModern .bPagination--modern {\n  min-height: 34px;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.unionTournamentReportsModal.modal-dialog {\n  width: min(760px, calc(100vw - 24px));\n  max-width: 760px;\n}\n.unionTournamentReportsModal .modal-content {\n  overflow: hidden;\n  border: 0;\n  border-radius: var(--radius-xl, 16px);\n  box-shadow: var(--shadow-xl, 0 24px 64px rgba(15, 23, 42, 0.22));\n}\n.unionTournamentReportsModal .modal-header {\n  padding: 13px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n.unionTournamentReportsModal .modal-title {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 17px;\n  font-weight: 800;\n}\n.unionTournamentReportsModal .modal-body {\n  padding: 18px 20px 20px;\n  background: var(--surface-page, #f8fafc);\n}\n.unionTournamentReportsModal .eEventPrintModal__intro {\n  margin-bottom: 18px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.unionTournamentReportsModal .eEventPrintModal__groupTitle {\n  margin: 0 0 8px;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n.unionTournamentReportsModal .eEventPrintModal__list {\n  display: grid;\n  gap: 8px;\n}\n.unionTournamentReportsModal .eEventPrintModal__item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  color: inherit;\n  text-align: left;\n  box-shadow: none;\n}\n.unionTournamentReportsModal .eEventPrintModal__item:hover {\n  border-color: var(--blue-400, #55a4d6);\n  background: var(--blue-50, #eef8ff);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n.unionTournamentReportsModal .eEventPrintModal__itemIcon {\n  display: inline-flex;\n  width: 38px;\n  height: 38px;\n  flex: 0 0 38px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n}\n.unionTournamentReportsModal .eEventPrintModal__itemIcon svg {\n  width: 19px;\n  height: 19px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.unionTournamentReportsModal .eEventPrintModal__itemCopy {\n  min-width: 0;\n  flex: 1;\n}\n.unionTournamentReportsModal .eEventPrintModal__itemHeading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 750;\n}\n.unionTournamentReportsModal .eEventPrintModal__format {\n  display: inline-flex;\n  padding: 2px 6px;\n  border-radius: 5px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 9.5px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.unionTournamentReportsModal .eEventPrintModal__itemDescription {\n  display: block;\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.4;\n}\n.unionTournamentReportsModal .eEventPrintModal__arrow {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 24px;\n  line-height: 1;\n}\n\n.unionTournamentReportParametersModal.modal-dialog {\n  width: min(480px, calc(100vw - 24px));\n  max-width: 480px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.unionTournamentReportParametersModal .modal-content {\n  max-height: min(720px, calc(100vh - 40px));\n  overflow: hidden;\n  border: 0;\n  border-radius: var(--radius-xl, 16px);\n  box-shadow: var(--shadow-xl, 0 24px 64px rgba(15, 23, 42, 0.22));\n}\n.unionTournamentReportParametersModal .modal-header {\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-subtle, #e3e8ef);\n}\n.unionTournamentReportParametersModal .modal-header .close {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  border-radius: var(--radius-md, 8px);\n  color: var(--text-muted, #64748b);\n  font-size: 22px;\n  text-shadow: none;\n}\n.unionTournamentReportTitle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.unionTournamentReportTitle__icon {\n  display: inline-flex;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 11px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n}\n.unionTournamentReportTitle__icon svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.unionTournamentReportTitle > span:last-child {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n}\n.unionTournamentReportTitle strong {\n  color: var(--text-strong, #142033);\n  font-size: 17px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n.unionTournamentReportTitle small {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 500;\n}\n.unionTournamentReportParametersModal .modal-body {\n  position: relative;\n  min-height: 0;\n  padding: 0 !important;\n  overflow: hidden;\n  background: var(--surface-page, #f8fafc);\n}\n.unionTournamentReportLoading {\n  position: absolute;\n  z-index: 5;\n  inset: 0;\n  display: flex;\n  min-height: 220px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 24px;\n  background: rgba(255, 255, 255, 0.94);\n  color: var(--text-strong, #0f172a);\n  text-align: center;\n}\n.unionTournamentReportLoading__spinner {\n  width: 28px;\n  height: 28px;\n  margin-bottom: 12px;\n  border: 3px solid var(--blue-50, #eef6fc);\n  border-top-color: var(--blue-500, #227ebd);\n  border-radius: 50%;\n  animation: unionTournamentReportSpin 0.75s linear infinite;\n}\n.unionTournamentReportLoading strong {\n  font-size: 14px;\n  font-weight: 800;\n}\n.unionTournamentReportLoading small {\n  margin-top: 3px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n@keyframes unionTournamentReportSpin {\n  to { transform: rotate(360deg); }\n}\n.unionTournamentReportParametersModal__body > form {\n  display: flex;\n  max-height: calc(100vh - 116px);\n  flex-wrap: wrap;\n  padding-top: 12px;\n  overflow-y: auto;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n}\n.unionTournamentReportParametersModal__body .bReportFormTitle {\n  display: none;\n}\n.unionTournamentReportParametersModal__body > form > .mb-3.mt-3,\n.unionTournamentReportParametersModal__body .bReportFormTitle + .mb-3,\n.unionTournamentReportParametersModal__body .form-group {\n  box-sizing: border-box;\n  width: calc(100% - 40px);\n  margin: 6px 20px !important;\n  padding: 12px 13px;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 11px;\n  background: var(--surface-card, #fff);\n}\n.unionTournamentReportParametersModal__body > form > .mb-3.mt-3,\n.unionTournamentReportParametersModal__body .bReportFormTitle + .mb-3 {\n  margin-top: 6px !important;\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n  line-height: 1.5;\n}\n.unionTournamentReportParametersModal__body .form-group > .d-flex {\n  align-items: center;\n  gap: 9px;\n}\n.unionTournamentReportParametersModal__body label,\n.unionTournamentReportParametersModal__body .form-check-label {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 650;\n}\n.unionTournamentReportParametersModal__body .form-control {\n  width: 100%;\n  min-height: 40px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #142033);\n  box-shadow: none;\n}\n.unionTournamentReportParametersModal__body .form-control:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.14));\n}\n.unionTournamentReportParametersModal__body form > .btn {\n  min-width: 96px;\n  min-height: 40px;\n  order: 98;\n  margin-top: 12px !important;\n  margin-bottom: 16px !important;\n  padding: 0 16px;\n  border-radius: var(--radius-md, 8px);\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: none;\n  box-shadow: none;\n}\n.unionTournamentReportParametersModal__body form > .btn-secondary {\n  margin-right: 8px !important;\n  margin-left: 20px !important;\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #475569);\n}\n.unionTournamentReportParametersModal__body form > .btn-primary {\n  order: 99;\n  margin-right: 20px !important;\n  margin-left: auto !important;\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.unionTournamentReportParametersModal__body form > .btn-primary:hover {\n  border-color: var(--action-primary-hover, #1a6da3);\n  background: var(--action-primary-hover, #1a6da3);\n}\n.unionTournamentReportParametersModal__body .eReportForm {\n  display: flex !important;\n  min-height: 0;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  padding: 0;\n  overflow: hidden;\n}\n.unionTournamentReportParametersModal__body .eReportForm__content {\n  min-height: 0;\n  overflow-y: auto;\n}\n.unionTournamentReportParametersModal__body .eReportDescription {\n  margin: 14px 18px 6px;\n  padding: 11px 13px;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 9px;\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-body, #334155);\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n.unionTournamentReportParametersModal__body .eReportSection {\n  margin: 13px 18px 0;\n  padding-bottom: 13px;\n  border-bottom: 1px solid var(--border-subtle, #e3e8ef);\n}\n.unionTournamentReportParametersModal__body .eReportSection:last-child {\n  border-bottom: 0;\n}\n.unionTournamentReportParametersModal__body .eReportSection__heading {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  margin-bottom: 9px;\n}\n.unionTournamentReportParametersModal__body .eReportSection__icon {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 7px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n  font-size: 11px;\n  font-weight: 800;\n}\n.unionTournamentReportParametersModal__body .eReportSection__copy {\n  min-width: 0;\n  flex: 1;\n}\n.unionTournamentReportParametersModal__body .eReportSection__title {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 750;\n}\n.unionTournamentReportParametersModal__body .eReportSection__hint {\n  margin-top: 1px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n.unionTournamentReportParametersModal__body .eReportSection__required {\n  margin-left: 3px;\n  color: var(--red-500, #d92d20);\n}\n.unionTournamentReportParametersModal__body .eReportToggleList {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 9px;\n}\n.unionTournamentReportParametersModal__body .eReportToggle {\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  gap: 14px;\n  padding: 8px 11px;\n  border-top: 1px solid var(--border-subtle, #e3e8ef);\n  background: var(--surface-card, #fff);\n}\n.unionTournamentReportParametersModal__body .eReportToggle:first-child {\n  border-top: 0;\n}\n.unionTournamentReportParametersModal__body .eReportToggle__copy {\n  min-width: 0;\n  flex: 1;\n}\n.unionTournamentReportParametersModal__body .eReportToggle__label {\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n  font-weight: 650;\n}\n.unionTournamentReportParametersModal__body .eReportToggle__hint {\n  margin-top: 1px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n}\n.unionTournamentReportParametersModal__body .eReportToggle .sit-switch {\n  flex: 0 0 auto;\n  margin: 0;\n}\n.unionTournamentReportParametersModal__body .eReportDateRange,\n.unionTournamentReportParametersModal__body .eReportDateRange__picker {\n  width: 100%;\n}\n.unionTournamentReportParametersModal__body .eReportDateRange .sit-dp__trigger {\n  height: 40px;\n  border-radius: var(--radius-md, 8px);\n  font-size: 13px;\n}\n.unionTournamentReportParametersModal__body .eReportActions {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  padding: 12px 18px;\n  border-top: 1px solid var(--border-subtle, #e3e8ef);\n  background: var(--slate-50, #f8fafc);\n}\n.unionTournamentReportParametersModal__body .eReportActions__status {\n  flex: 1;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n.unionTournamentReportParametersModal__body .eReportActions .eDsButton {\n  min-width: 92px;\n  min-height: 38px;\n  margin: 0 !important;\n  padding: 0 14px;\n  border-radius: var(--radius-md, 8px);\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: none;\n  box-shadow: none;\n}\n.unionTournamentReportParametersModal__body .eReportActions .eDsButton--secondary {\n  border: 1px solid var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #475569);\n}\n.unionTournamentReportParametersModal__body .eReportActions .eDsButton--primary {\n  border: 1px solid var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.unionTournamentReportParametersModal:has(.sit-dp__pop) .modal-content,\n.unionTournamentReportParametersModal:has(.sit-dp__pop) .modal-body {\n  overflow: visible;\n}\n.unionTournamentReportParametersModal .eReportDateRange .sit-dp__pop {\n  position: fixed;\n  z-index: 2147483002;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  max-width: calc(100vw - 24px);\n  max-height: calc(100vh - 24px);\n  transform: translate(-50%, -50%);\n  animation: none;\n}\n.unionTournamentReportParametersModal .react-datepicker-popper {\n  z-index: 2147483002;\n}\n\n@media (max-width: 600px) {\n  .unionTournamentReportParametersModal.modal-dialog {\n    width: calc(100vw - 20px);\n  }\n  .unionTournamentReportParametersModal__body .form-group,\n  .unionTournamentReportParametersModal__body > form > .mb-3.mt-3,\n  .unionTournamentReportParametersModal__body .bReportFormTitle + .mb-3 {\n    width: calc(100% - 28px);\n    margin-right: 14px !important;\n    margin-left: 14px !important;\n  }\n}\n.unionTournamentReportsModal__intro {\n  margin-bottom: 12px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.unionTournamentReportsModal__group h3 {\n  margin: 0 0 7px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n.unionTournamentReportsModal__list {\n  display: grid;\n  gap: 6px;\n}\n.unionTournamentReportsModal__list > button {\n  display: grid;\n  grid-template-columns: 30px minmax(0, 1fr) 16px;\n  align-items: center;\n  gap: 9px;\n  width: 100%;\n  min-height: 52px;\n  padding: 8px 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  text-align: left;\n  box-shadow: none;\n}\n.unionTournamentReportsModal__list > button:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n}\n.unionTournamentReportsModal__icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 7px;\n  background-color: var(--blue-50, #eef6fc);\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 3h8l4 4v14H6zM14 3v5h5M9 13h6M9 17h4' fill='none' stroke='%23227ebd' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 16px;\n}\n.unionTournamentReportsModal__list > button > span:nth-child(2) {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n.unionTournamentReportsModal__list strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 12.5px;\n  font-weight: 750;\n}\n.unionTournamentReportsModal__list small {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 1.4;\n}\n.unionTournamentReportsModal__list b {\n  color: var(--text-subtle, #94a3b8);\n  font-size: 18px;\n  font-weight: 400;\n  text-align: center;\n}\n\n@media (max-width: 760px) {\n  .unionTournamentsModern .gridModernSearch,\n  .unionTournamentsModern .gridModernFiltersAnchor,\n  .unionTournamentsModern .gridModernFilterButton,\n  .unionTournamentsModern .gridInlineActions {\n    width: 100%;\n  }\n  .unionTournamentsModern .gridModernFilterPopover {\n    width: 100vw;\n    max-width: none;\n  }\n}\n\n@media (max-width: 1217px) {\n  .unionTournamentsPage {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n}\n\n.utmSchoolAdmins__download {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 14px;\n  border: 1px solid var(--action-primary, #227ebd);\n  border-radius: var(--radius-md, 8px);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: none;\n}\n\n.utmSchoolAdmins__download svg {\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.utmSchoolAdmins__download:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.utmSchoolAdmins__headerTools {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.utmSchoolAdmins__headerTools .gridModernSearch {\n  width: 260px;\n}\n\n.utmSchoolAdmins__filterBackdrop {\n  position: fixed;\n  z-index: 2147483000;\n  inset: 0;\n}\n\n.utmSchoolAdmins .utmParticipants__tableWrap table {\n  font-family: var(--font-body, 'Inter', system-ui, sans-serif);\n}\n\n.utmSchoolAdmins .utmParticipants__tableWrap th {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.045em;\n  text-transform: uppercase;\n}\n\n.utmSchoolAdmins .utmParticipants__tableWrap td {\n  color: var(--text-body, #334155);\n  font-size: 13px;\n}\n\n.utmSchoolAdmins .utmParticipants__tableWrap td strong {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-weight: 750;\n}\n\n@media (max-width: 900px) {\n  .utmSchoolAdmins__headerTools,\n  .utmSchoolAdmins__headerTools .gridModernSearch {\n    width: 100%;\n  }\n}\n.utmEligibleAddModal__events {\n  display: grid;\n  gap: 7px;\n  max-height: 240px;\n  margin-top: 14px;\n  padding: 12px;\n  overflow-y: auto;\n  border: 1px solid #dbe4ee;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.utmEligibleAddModal__events > div:first-child {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 3px;\n}\n\n.utmEligibleAddModal__events > div:first-child span,\n.utmEligibleAddModal__events p {\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.utmEligibleAddModal__eventTools {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 2px 0 5px;\n}\n\n.utmEligibleAddModal__eventTools > label {\n  display: flex;\n  flex: 1 1 220px;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n  height: 36px;\n  margin: 0;\n  padding: 0 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #64748b;\n}\n\n.utmEligibleAddModal__eventTools > label input {\n  width: 100%;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.utmEligibleAddModal__eventTools > div {\n  display: inline-flex;\n  gap: 6px;\n}\n\n.utmEligibleAddModal__eventTools button {\n  min-height: 34px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #227ebd;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.utmEligibleAddModal__eventTools button:hover:not(:disabled) {\n  border-color: #227ebd;\n  background: #eff8fc;\n}\n\n.utmEligibleAddModal__eventTools button:disabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.utmEligibleAddModal__selectAll {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  color: #344054;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.utmEligibleAddModal__selectAll input { position: absolute; opacity: 0; }\n.utmEligibleAddModal__selectAll span { position: relative; width: 34px; height: 20px; border-radius: 999px; background: #cbd5e1; transition: background .15s ease; }\n.utmEligibleAddModal__selectAll span::after { position: absolute; top: 3px; left: 3px; width: 14px; height: 14px; border-radius: 50%; background: #fff; content: ''; transition: transform .15s ease; }\n.utmEligibleAddModal__selectAll input:checked + span { background: #227ebd; }\n.utmEligibleAddModal__selectAll input:checked + span::after { transform: translateX(14px); }\n\n.utmEligibleAddModal__events > label {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  margin: 0;\n  padding: 8px 9px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.utmEligibleAddModal__events > label > span {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.utmEligibleAddModal__events > label small {\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.45;\n}\n\n@media (max-width: 620px) {\n  .utmEligibleAddModal__eventTools {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .utmEligibleAddModal__eventTools > label {\n    flex-basis: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
